import { ProfileService } from './../../../services/profile.services';
import {
  Component,
  OnDestroy,
  ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver,
  OnInit,
  ElementRef,
  AfterContentInit
} from '@angular/core';
import {
  ProcurementProjectDTO,
  ProcurementProjectLotDTO,
  LotDTO,
  CompanyToInviteDTO,
  AwardDTO,
  RequestMaterialDTO,
  CriteriaDTO,
  ActionResultDTO,
  CriteriaDefDTO,
  DossierSituation,
  ActionDefinitionDTO,
  ResultTypeDTO,
  getResultTypeDTOLevel,
  RepresentativeDTO,
  ProjectRelationTable,
  ProjectRelationDTO,
  ProjectEntityDTO,
  CustomFieldDTO
} from '../../api/plyca-dtos-v2';
import { ActionDTO, ProcurementProjectDefinitionsDTO, ProcurementProjectStepsDefinitionDTO, ProcurementProjectStepDTO, DocumentClassDTO, MasterDataDTO }
  from '../../api/plyca-dtos';
import { PlycaDataService } from '../../../services/plyca.service';
import { UserService } from '../../user.service';
import { FormService } from '../../components/forms/form.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FormConfig, FormGroupConfig } from '../../components/forms/form.objects';
import { SearchSettingDTOModal, searchGenericComponent } from '../../components/search/searchGeneric.component';
import { searchCPVComponent } from '../../components/searchCPV/searchCPV.component';
import { ProcurementProjectValidations } from './procurementProject.validation';
import {
  FieldConfig
} from '../../api/contract-notice-dto';
import { formPlycaComponent } from '../../components/forms/formPlyca.component';
import { PaginationDTO } from '../../api/PaginationModel';
import {
  saveDossierPopupComponent,
  SaveDossierData
} from './saveDossierPopup.component';
import { SearchLotsAwardsPopupComponent } from './searchLotsAwardsPopup.component';

import * as lodash from 'lodash';
import { UIService, generateRandomIdentifier } from '../../ui.service';
import { map, flatMap, switchMap, catchError, finalize, tap, take, skipWhile } from 'rxjs/operators';

import { TaskHandler } from '../../tasks/TaskHandler';
import { Observable, of, throwError, EMPTY, forkJoin } from 'rxjs';
import { Configuration } from '../../conf/app.constants';
import {
  HelpService,
  HelpType
} from '../../components/common/help/help.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { DossierModelsService } from '../dossierModels/DossierModels.service';
import { formElementComponent } from '../../components/forms/formElement.component';
import { ServiceLocator } from '../../ServiceLocator';
import { AppConfiguration } from '../../conf/app.configuration';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { MenuItem } from 'primeng-lts/api';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { ActionsProcessComponent } from '../../actions/actions.process.component';
import { I18nData } from '../../api/plyca-dtos';
import { ProjectDefaultFieldDTO } from '../../api/plyca-dtos';
import { mergeMap } from 'rxjs/operators';
import {
  MasterData
} from '../../api/contract-notice-dto';
import { PropertyService } from '../../properties/property.service';
import { ProcurementProjectValidationsINECO } from '../../ineco/procurementProject/procurementProjectINECO.validation';




// external js function declaration
// PARA INCLUIR FUNCIONES A LA FE POR ADAPTACIÓN
// ......................assets/js/adap.js
declare var FE: any;
@Component({
  selector: 'procurementProject',
  templateUrl: 'procurementProject.template.html',
  providers: [ProcurementProjectValidations, ProcurementProjectValidationsINECO]
})
export class procurementProjectComponent extends TaskHandler
  implements OnInit, OnDestroy, AfterContentInit {
  loaded = false;
  procesandoTarea = false;
  // PARA INDICAR SI SE ENTRA EN LA PANTALLA EN MODO MODELO (SOLO EN ALTAS)
  model = false;

  // INFORMACION DEL EXPEDIENTE
  dossierId: string;
  dossier: ProcurementProjectDTO;


  items: MenuItem[];
  activeItem: MenuItem;

  @ViewChild('formContainer', { read: ViewContainerRef, static: true })
  formContainer: ViewContainerRef;
  form: formPlycaComponent;

  // Variable que indica si se está en la pantalla previa para seleccionar la configuracion a utilizar
  selectStepMode: boolean;

  // Listado de configuraciones definidas en ProcurementProjectDefinition.json
  stepsDefinition: ProcurementProjectDefinitionsDTO;
  // Configuracion de ficha utiliza
  stepDefinition: ProcurementProjectStepsDefinitionDTO;

  //  index = 0;
  // Paso de la Ficha en el que nos encontramos
  currentStep = 0;

  dossierPopupVisible = false;
  models: any[];
  formid: any;
  formUUID: string;
  readonly = false;
  TRAMITACIONOK = false;
  isNewDossier = false;
  appConfig: AppConfiguration;
  cancelCreate = true; // Solo es false cuando se pulsa en crear expediente desde la modal de selección
  modalOpened: boolean;

  public static resetChange(changes?: any) {
    let oldValue = changes.oldValue;
    let newValue = changes.newValue;
    // si el valor nuevo NO es nulo y el valor antiguo no es nulo y son diferentes las empresas se resetea el representante
    // si se elimina el valor de la emprea tambien se limpia
    let reset = ((oldValue && newValue) && (oldValue.identifier != newValue.identifier)) || (newValue === undefined);
    console.log('======resetChange', reset);
    return reset;
  }


  constructor(
    public plycaService: PlycaDataService,
    private configuration: Configuration,
    public userService: UserService,
    public dossierModelService: DossierModelsService,
    public formService: FormService,
    public helpService: HelpService,
    public activatedRoute: ActivatedRoute,
    public translate: TranslateService,
    public dialogService: DialogService,
    public uiService: UIService,
    public translationService: TranslateService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private procurementProjectValidations: ProcurementProjectValidations,
    private procurementProjectValidationsIneco: ProcurementProjectValidationsINECO,
    private router: Router,
    private headerActionsService: HeaderActionsService,
    private plycaErrorHandler: PlycaErrorHandler,
    private elem: ElementRef,
    private profileService: ProfileService,
  ) {

    super();
    this.appConfig = ServiceLocator.injector.get(AppConfiguration);


  }

  private helpContextDossierModel() {
    // AYUDA: Pantalla modal de selescion del modelo
    this.subscribe(
      this.helpService.showContextHelpObservable(HelpType.FE_SELECC_MODELO));
  }

  onCloseDossierModel() {
    if (this.cancelCreate) {

      // AYUDA: Pantalla modal de selescion del modelo
      this.subscribe(
        this.helpService.showContextHelpObservable(HelpType.TIPO_FICHA));
    }
  }
  private waitUntilServicesLoaded(): Observable<boolean> {
    return this.profileService.getInitCompleted().pipe(
      skipWhile((completed: boolean) => !completed),
      take(1)
    );
  }
  ngOnInit(): void {
    this.waitService.startWaiting();
    this.subscribe(
      this.waitUntilServicesLoaded(),
      () => {
        if (this.task) {
          console.log('INVOCACIONA PROCUREMENTPROJECT DESDE TAREA', this.task);
          this.dossierId = this.task.division.project.identifier;
          console.log('Entrando a editar project', this.dossierId);
          this.waitService.startWaiting();
          this.subscribe(this.loadStepsDefinition().pipe(
            finalize(() => {
              console.log('Componente cargado');
              this.subscribe(this.form.getCompleted(),
                (ok) => {
                  if (ok) {

                    this.waitService.cancelWaiting();
                    if (this.dossierId && this.form.formConfig.model) {
                      this.setContractBasedCatalog(this.form.formConfig.model);
                    }
                  }
                }
              )
            })
          ), (ok) => {

            // console.log('Wait quitado');
          },
            (err) => {
              console.log('Error en la carga del formulario');
              console.log(err);
            }
          );

        } else {
          this.subscribe(
            this.helpService.showContextHelpObservable(HelpType.TIPO_FICHA));
          this.subscribe(this.activatedRoute.params, params => {
            this.dossierId = params['id'];

            this.subscribe(this.profileService.isUserCanPrepareProject(this.dossierId, undefined)
              .pipe(
                tap((can) => {
                  can = this.dossierId === undefined || can;
                  this.readonly = !can;
                  console.log('INVOCACIONA PROCUREMENTPROJECT DESDE url', params['id']);
                  console.log('Entrando a editar project', this.dossierId);

                  this.subscribe(this.activatedRoute.queryParams, queryParams => {

                    this.model = queryParams['model'];
                    this.formid = queryParams['formid'];
                    this.formUUID = queryParams['formUUID'];
                    // Si se puede preparar, pero se le pasa el parametro de solo lectura
                    if (can && queryParams['readonly']) {
                      this.readonly = true;
                    }

                    this.subscribe(this.loadStepsDefinition().pipe(finalize(() => {

                      console.log('Componente cargado');
                      if (this.form) {
                        this.subscribe(this.form.getCompleted(),
                          (ok) => {
                            if (ok) {

                              this.waitService.cancelWaiting();
                              this.loaded = true;
                              if (this.dossierId && this.form.formConfig.model) {
                                this.setContractBasedCatalog(this.form.formConfig.model);
                              }
                              // Se muestran las validaciones al abrir la pantalla
                              if (!this.readonly) {
                                this.verifyDossier(false, false);
                              }
                            }
                          }
                        );


                      } else {
                        this.waitService.cancelWaiting();
                        this.loaded = true;
                      }
                    })), (ok) => {
                      console.log('Ok  en la carga del formulario');
                    },
                      (err) => {
                        console.log('Error en la carga del formulario');
                        console.log(err);
                      });


                  });
                }))
            );
          });
        }
      }
    );

  }

  ngAfterContentInit(): void {
    this.setHeaderNuevo();

  }

  ngOnDestroy(): void {
    this.form = undefined;
    this.headerActionsService.clearActions();
    this.formContainer = undefined;
    super.ngOnDestroy();
  }

  public isLoaded(): boolean {
    return this.loaded;
  }

  private setHeaderNuevo(txt?: string) {
    // *****
    this.headerActionsService.setTaskDescription(
      this.elem,
      txt
        ? this.translate.instant('ProcurementProject.new') + ': ' + txt
        : this.translate.instant('ProcurementProject.new'),
      'fas fa-plus',
      true
    );



  }
  private setHeaderPreparar(txt?: string) {

    this.headerActionsService.setTaskDescription(
      this.elem,
      txt
        ? txt
        : 'ERROR',
      'fas fa-pen',
      true
    );

  }

  private setHeaderNuevoModelo(txt?: string) {
    // *****
    this.headerActionsService.setTaskDescription(
      this.elem,
      txt
        ? this.translate.instant('ProcurementProject.new') + ' desde modelo ' + txt
        : this.translate.instant('ProcurementProject.new'),
      'fas fa-plus',
      true
    );

  }


  private setActionButtons() {
    this.waitService.startWaiting();
    /*
  this.headerActionsService.addAction(
  'Validar',
  'fa far fa-question-circle',
  'btn-warning',
  true
  ).subscribe(success => {
  this.validate();
  });*/
    this.headerActionsService.clearActions();
    if (!this.readonly) {
      this.headerActionsService.addDivider();
      this.subscribe(this.headerActionsService
        .addAction(
          'ProcurementProject.calculate.action',
          'fas fa-lg fa-calculator',
          'btn-secondary',
          this.isBudgetCalculateVisible.bind(this)
        ), () => {
          this.calculateBudgets();
        });

      this.subscribe(this.headerActionsService
        .addAction(
          'ProcurementProject.verify',
          'fas fa-lg fas fa-check',
          'btn-secondary',
          () => this.dossier
        ), () => setTimeout(() => {
          // Se retrasa  un segundo para que de te tiempo a hacer los eventos del value, cada vez que se ejecuta el botón
          this.verifyDossier(true, true);
        }, 500)
      );
      this.subscribe(this.headerActionsService
        .addActionWithType(
          'General.save',
          'fas fa-lg fa-save',
          'btn-warning',
          'submit',
          true
        ), () => {
          this.saveAction();
          // this.saveNew();
        });
    }


    this.subscribe(this.headerActionsService
      .addAction(
        'ProcurementProject.previous',
        'fas fa-lg fa-backward',
        'btn-primary',
        this.hasPreviousStep.bind(this)
      ), () => {
        this.previousStep();
      });
    this.subscribe(this.headerActionsService
      .addAction(
        'ProcurementProject.next',
        'fas fa-lg fa-forward',
        'btn-primary',
        this.hasNextStep.bind(this)
      ), () => {
        this.nextStep();
      });
    this.headerActionsService.addDivider();
    if (!this.readonly) {
      this.subscribe(this.headerActionsService
        .addAction(
          'General.cancel',
          'fas fa-1-25x fa-times',
          'btn-outline-secondary',
          true
        ), () => {
          this.cancel();
        });
    }
    if (this.readonly) {
      this.headerActionsService.addDivider();
      this.subscribe(this.headerActionsService
        .addAction(
          'General.back',
          'fas fa-chevron-left',
          'btn-outline-secondary',
          true
        ), () => {
          this.uiService.routeBack();
        });
    }


  }

  private loadStepsDefinition(): Observable<any> {
    console.log('loadStepsDefinition + waitservice');
    this.waitService.startWaiting();
    // 1. LEER CONFIGURACIONES
    return this.plycaService
      .getProcurementProjectSteps(
        'procurementProject/procurementProjectDefinition.json'
      ).pipe(flatMap(

        (stepsDef: ProcurementProjectDefinitionsDTO) => {
          console.log('resultado de getProcurementProjectSteps');
          this.stepsDefinition = stepsDef;
          console.log('2.1) SI ES UN EXPEDIENTE NUEVO');
          // 2.1) SI ES UN EXPEDIENTE NUEVO
          //   a) Si viene como modelo, con formid
          //   b) SI HAY MAS DE UN TIPO DE FICHA SE ESTABLECE EL MODO SELECTSTEPMODE
          //   c) SI SOLAMENTE HAY UNO SE ACCEDE DIRECTAMENTE AL FORMULARIO CORRESPONDIENTE (selectStepDefinition)

          if (this.formUUID !== undefined && this.formUUID != null) {
            return this.selectStepDefinition(this.stepsDefinition.definitions.find(x => x.formUUID === this.formUUID), this.model);
          } else if (this.formid) {
            console.log(' a) Si viene como modelo, con formid');
            return this.selectStepDefinition(this.stepsDefinition.definitions.find(x => x.identifier === this.formid), this.model);
          } else if (!this.dossierId) {
            // ATENCIÓN. Opcion desactivada porque por ahora solamente se puede partir de un modelo si se parte
            // de la pantalla de seleccion de tipo de ficha

            // Si solamenet hay una definicion la cargamos directamente
            // if (this.stepsDefinition.definitions.length === 1) {
            //   this.setHeaderNuevo(this.stepsDefinition.definitions[0].name);
            //   this.selectStepDefinition(this.stepsDefinition.definitions[0]);
            // } else {
            //   this.selectStepMode = true;
            // }

            // Filtramos por perfil si la definicion los limita
            this.stepsDefinition.definitions = this.stepsDefinition.definitions.filter((def: ProcurementProjectStepsDefinitionDTO) => !def.profiles || this.userService.hasRoles(def.profiles))
            this.selectStepMode = true;
            return EMPTY;
          } else {
            // 2.2) SI EL EXPEDIENTE EXISTE SE LEE Y SE RECUPERA EL FORMULARIO A ABRIR DEL CAMPO FORMID
            console.log(' 2.2) SI EL EXPEDIENTE EXISTE SE LEE Y SE RECUPERA EL FORMULARIO A ABRIR DEL CAMPO FORMID');
            return this.plycaService
              .getProcurementProject(this.dossierId)
              .pipe(flatMap(
                result => {
                  console.log('resultado de getProcurementProject');
                  // 1. RECUPERAR FORMULARIO DE TAREA
                  let formId = this.getFormIdFromTask(result.formId);

                  let selectedStep;
                  if (!formId) {// 2. SI NO LLEGA SE RESPETA EL QUE ESTA EN EL EXPEDIENTE, QUE ESTA ACTIVO
                    formId = result.formId;
                    // Si le pasa por tarea
                    // Buscamos la definición de formulario asociada al project
                    if (formId) {
                      selectedStep = this.stepsDefinition.definitions.find(
                        step => step.identifier === formId
                      );
                      console.log('SELECCIONANDO FORMULARIO: ', formId, selectedStep);
                    }
                    // HACK (NO DEBERIA PASAR): si no se localiza la definicion del formulario utilizamos la primera
                    if (!selectedStep) {
                      selectedStep = this.stepsDefinition.definitions[0];
                      console.log(
                        'SELECCIONANDO FORMULARIO. NO SE HA LOCALIZADO EL FORMULARIO DEL PROYECTO. APERTURA POR DEFECTO: ',
                        formId,
                        selectedStep
                      );
                    }
                    return this.selectStepDefinition(selectedStep);
                  } else {// 3. Se trae las definiciones de todos los formularios, porque puede ser que esté deshabilitado
                    let url = '/userAPI/v1/projectDefinitions';
                    return this.plycaService.query<any>(url).pipe(
                      tap((result: PaginationDTO<any>) => {
                        let defs: ProcurementProjectDefinitionsDTO[] = [];
                        if (result && result.content) {
                          // Convertir cada elemento de result.content al tipo ProcurementProjectDefinitionsDTO
                          defs = result.content.map((item: any) => item as ProcurementProjectDefinitionsDTO);
                          // Se filtra por idformulario y en el caso de que haya varios se selecciona el primero

                          if (formId) {
                            selectedStep = defs[0].definitions.find(
                              step => step.identifier === formId
                            );
                            console.log('SELECCIONANDO FORMULARIO: ', formId, selectedStep);
                          }

                          if (!selectedStep) {
                            selectedStep = defs[0].definitions[0];
                            console.log(
                              'SELECCIONANDO FORMULARIO. NO SE HA LOCALIZADO EL FORMULARIO DEL PROYECTO. APERTURA POR DEFECTO: ',
                              formId,
                              selectedStep
                            );
                          }

                        }

                      }),
                      flatMap(() => {
                        return this.selectStepDefinition(selectedStep);
                      })
                    );
                  }
                }
              ));
          }
        }

      ),
        tap(() => this.setActionButtons())
        ,
        catchError((error: any) => {
          console.log(error);
          return throwError(error);
        })
      );
  }

  // ABRIR EL DIALOGO DE CREACION DE EXPEDIENTE (VACIO O UTILIZANDO UN MODELO)
  showCreateDossierPopup(stepDefinition: ProcurementProjectStepsDefinitionDTO) {
    this.stepDefinition = stepDefinition;
    this.subscribe(this.dossierModelService.getModels([DossierSituation.Normal]), result => {
      // TODO: FILTRAR MODELOS DEL TIPO DE EXPEDIENTE SELECCIONADO
      if (result) {
        this.models = result.content.filter(project => project.formId === stepDefinition.identifier);

        if (this.models && this.models.length > 0) {
          // Cuando se pulsa en iniciar expediente y hay modelos, se muestra la modal de selcción de modelos
          // y se carga el modelo en otro sitio
          this.helpContextDossierModel();
          this.dossierPopupVisible = true;
        } else {
          // Si se pulsa en iniciar expediente y no hay modelos, se carga la definición de la ficha correspondiente
          this.models = [];
          this.subscribe(this.selectStepDefinition(stepDefinition).pipe(finalize(() => {
            this.subscribe(this.form.getCompleted(),
              (ok) => {
                if (ok) {
                  this.waitService.cancelWaiting();
                }
              }
            )

          })));
        }
      } else {
        // Por aquí en principio no pasa nunca
        this.models = [];
        this.subscribe(this.selectStepDefinition(stepDefinition).pipe(finalize(() => {
          this.subscribe(this.form.getCompleted(),
            (ok) => {
              if (ok) {
                this.waitService.cancelWaiting();
              }
            }
          )

        })));
      }


    });
  }

  cancelCreateDossierPopup() {
    this.stepDefinition = undefined;
    this.models = [];
    this.dossierPopupVisible = true;
  }

  createDossierFromModel(model: any) {
    this.waitService.startWaiting();
    this.subscribe(this.dossierModelService
      .createDossierFromModel(model).pipe(finalize(() => {

        this.waitService.cancelWaiting();
      })), (action: ActionResultDTO) => {
        console.log(
          'EXPEDIENTE CREADO A PARTIR DEL MODEL: ',
          model.identifier,
          action
        );

        if (action.objectResult) {
          this.dossierId = action.objectResult.identifier;
          console.log('Entrando a editar project', this.dossierId);
          this.subscribe(this.loadStepsDefinition().pipe(finalize(() => {

            this.setHeaderNuevoModelo(this.stepDefinition.name);
            // *****

            this.subscribe(this.form.getCompleted(), (ok) => {
              if (ok) {
                this.waitService.cancelWaiting();
              }
            }
            )
            this.uiService.showSuccess(this.translate.instant('GenericDossier.created', {
              identifier: this.dossierId
            })
              ,
              this.translate.instant('General.info'),
              'success'
            );
          })));
        }
      });
  }

  createNew(stepDefinition: any) {
    this.waitService.startWaiting();

    this.subscribe(this.selectStepDefinition(stepDefinition).pipe(

      finalize(() => {
        if (this.form) {
          this.subscribe(this.form.getCompleted(),
            (ok) => {
              if (ok) {
                this.loaded = true;
                this.selectStepMode = false;
                this.waitService.cancelWaiting();
              }
            }


          )
        } else {
          console.log('NO HAY FORMULARIO');
          this.loaded = true;
          this.selectStepMode = true;
          this.waitService.cancelWaiting();
        }
      }

      )));
  }

  private selectStepDefinition(
    stepDefinition: ProcurementProjectStepsDefinitionDTO,
    model?: boolean
  ): Observable<any> {
    console.log('selectStepDefinition');

    this.dossierPopupVisible = false;
    this.model = model;
    console.log(this.model);
    this.stepDefinition = stepDefinition;

    this.currentStep = 0;





    // si es un nuevo expediente utilizar para la precarga la llamada a new con la configuración del step seleccionado
    if (!this.dossierId) {

      this.dossierId = 'new';
      this.isNewDossier = true;

      // Si el step tiene configuraciones se utilizan para invocar al  new
      if (stepDefinition.configurations) {
        this.dossierId += '?configurations=' + stepDefinition.configurations;
      }

      if (this.model) {
        this.setHeaderNuevo(this.translate.instant('ProcurementProject.models.titleNew') + stepDefinition.name);
      } else { this.setHeaderNuevo(this.translate.instant(stepDefinition.name)); }

      // Como se crea el expediente de cero, no viene por tarea, se muesta la ayuda de la pantalla
      // AYUDA: Pantalla inicial de selección de tipo de nuevo expediente
      this.subscribe(
        this.helpService.showContextHelpObservable(HelpType.CREATE_DOSSIER));

      return this.loadDossier();


    } else {
      console.log('Expediente existente, preparar');
      this.setHeaderPreparar(stepDefinition.name);
      // si el expeidente ya esta creado se invoca al loadDossier con la expansion necesaria

      // AYUDA: Pantalla de edicion de la ficha
      let helpTags = [];
      helpTags.push(HelpType.CREATE_DOSSIER);
      if (this.task) { // ayuda con tarea
        this.subscribe(this.helpService.getStoreTagsObservable().pipe(
          switchMap((taskTags) => {
            helpTags = taskTags.concat(helpTags);
            return this.helpService.showContextHelpObservable(helpTags)
          })));
      } else { // ayuda sin tarea
        this.subscribe(
          this.helpService.showContextHelpObservable(helpTags));
      }

      let expansionDossier: string;
      if (this.dossierId && this.dossierId.indexOf('?') > 0) {
        expansionDossier = '&';
      } else {
        expansionDossier = '?';
      }
      expansionDossier = expansionDossier + 'expand=expansionSet:subclass_complete';
      return this.loadDossier(expansionDossier);
    }
  }

  private loadDossier(expansion?: string): Observable<any> {
    console.log('loadDossier');
    this.loaded = false;

    return this.plycaService
      .getProcurementProject(this.dossierId, expansion).pipe(

        map(

          (result) => {
            console.log('resultado de getProcurementProject');
            console.log(result);
            console.log('Llamada a processDossierForm');

            return this.processDossierForm(result);
          }



        ));

  }

  private processDossierForm(_dossier: ProcurementProjectDTO): Observable<any> {
    console.log('processDossierForm');
    // etiquetas
    this.loaded = false;
    this.dossier = _dossier;
    this.dossierId = this.dossier.identifier;
    if (this.dossier.documentClass) {
      this.model =
        this.dossier.documentClass.identifier === this.appConfig.getValue('dossierModel.documentClass');
    }
    // Si tiene parametros establece el valor de los mismos
    if (this.isNewDossier && this.stepDefinition.default) {
      lodash.merge(this.dossier, this.stepDefinition.default);
    }

    // Si tiene parametros establece el valor de los mismos
    if (this.isNewDossier) {
      // Formato json cliente web
      if (this.stepDefinition.default) {
        lodash.merge(this.dossier, this.stepDefinition.default);
      }
      // Formato json servidor
      if (this.stepDefinition.defaultFields) {
        this.stepDefinition.defaultFields.forEach((f: ProjectDefaultFieldDTO) => {
          let defaultValue;
          console.log('Estableciendo el campo ' + f.jsonField + ' con valor ' + f.value);
          if (f.value && f.value.includes('<>')) {
            let idParts = f.value.split('<>');
            this.plycaService.getMasterDataValues(idParts[1], idParts[0], true)
              .pipe(take(1))
              .subscribe((data: PaginationDTO<MasterData>) => {
                if (data && data.content && data.content.length > 0) {
                  defaultValue = data.content[0];
                  this.formService.setNestedProperty(this.dossier, f.jsonField, defaultValue);
                }
              });
          } else if (f.value && (f.value === 'true' || f.value === 'false')) {
            let defaultValueBoolean;
            let _this = this as unknown as formElementComponent;
            defaultValueBoolean = this.formService.evalExpression(f.value,
              null, null, _this, null);
            this.formService.setNestedProperty(this.dossier, f.jsonField, defaultValueBoolean);
          } else {
            this.formService.setNestedProperty(this.dossier, f.jsonField, f.value);
          }

        });
      }
    }

    // establecer el identificador del formulario
    //this.dossier.formId = '' + this.stepDefinition.identifier;

    if (this.dossier.formId == null) {
      this.dossier.formId = this.formid;
    }
    if (this.dossier.formId == null) {
      this.dossier.formId = this.stepDefinition.identifier;
    }

    this.dto2ViewModel(this.dossier);

    console.log('llamada a loadForms');
    this.selectStepMode = false;
    // this.loaded = true;
    return this.loadForms(this.currentStep);

  }

  previousStep() {
    if (this.hasPreviousStep()) {
      this.changeTab(this.getCurrentStep().value - 1);
    }
  }

  nextStep() {
    if (this.hasNextStep()) {
      this.changeTab(this.getCurrentStep().value + 1);

    }
  }

  hasPreviousStep(): boolean {
    return this.getCurrentStep().value > 0;
  }

  hasNextStep(): boolean {
    return this.getCurrentStep().value < this.stepDefinition.steps.length - 1;
  }

  getCurrentStep(): ProcurementProjectStepDTO {
    return this.stepDefinition.steps.find(t => t.value === this.currentStep);
  }

  changeTab(newStep: number) {
    console.log('new Index: ' + newStep);
    this.waitService.startWaiting();
    // this.loading.next(new LoadingInfo(true));


    if (this.readonly) {
      if (newStep !== undefined) {
        this.currentStep = newStep;
      }
      // Se recargan los datos del formulario de la ficha
      this.subscribe(this.processDossierForm(this.dossier),
        (ok) => {
          if (ok) {
            // this.form.validate(validationContext, this.viewModel2DTO());
            console.log('Componente cargado');
            if (!this.procesandoTarea) {
              this.waitService.cancelWaiting();
            }
          }
        }
      );


    } else {

      this.subscribe(this.save(newStep).pipe(finalize(
        () => {
          this.subscribe(this.helpService.showContextHelpObservable(HelpType.CREATE_DOSSIER).pipe(

            finalize(() => {

              console.log('Componente cargado');
              if (this.form && !this.form.completed) {

                this.subscribe(this.form.getCompleted().pipe(

                  finalize(() => {
                    this.waitService.cancelWaiting();
                    this.loaded = true;

                  })))
              } else {

                this.waitService.cancelWaiting();
                this.loaded = true;
              }
            }

            )));
          console.log('Guardado y al siguiente paso:');
        }


      )));
    }

  }

  /*
   * LOGICA DE NEGOCIO DEL FORMULARIO
   */

  // invocar en la consulta para adaptar el dto al modelo de vista
  dto2ViewModel(exp: ProcurementProjectDTO) {
    let _cpvs: Array<any> = [];
    let _classificationCompany: Array<any> = [];
    let _selectionAwardCriteria: Array<any> = [];
    let _partialDeliveries: Array<any> = [];
    let _unitPrices: Array<any> = [];
    let _requestedMaterial: Array<any> = [];
    let _tarrif: Array<any> = [];
    let _specialExecutionCondition: Array<any> = [];

    // Si viene desde tarea le pone el de tarea, sino se le pasa el de Base Datos
    if (this.dossier && this.dossier.formId !== undefined && this.dossier.formId !== null) {
      let formid = this.getFormIdFromTask(this.dossier.formId);
      if (formid) {
        this.dossier.formId = formid;
      }
    }

    // si hay desglose de lotes
    if (exp.breakdownLot.apportioned) {
      if (exp.breakdownLot.lots) {
        exp.breakdownLot.lots.forEach((lote: ProcurementProjectLotDTO) => {
          this.unificarLotes(_cpvs, lote, 'cpvs');
          this.unificarLotes(
            _classificationCompany,
            lote,
            'classificationCompany'
          );
          this.unificarLotes(
            _selectionAwardCriteria,
            lote,
            'selectionAwardCriteria'
          );
          this.unificarLotes(
            _partialDeliveries,
            lote,
            'partialPeriod.partialDeliveries'
          );
          this.unificarLotes(_unitPrices, lote, 'budget.unitPrice');
          this.unificarLotes(
            _requestedMaterial,
            lote,
            'budget.requestedMaterial'
          );
          this.unificarLotes(_tarrif, lote, 'specialEconomicTerm.tariff');
          this.unificarLotes(_specialExecutionCondition, lote, 'specialExecutionCondition');
        });
      }
    } else {
      //      this.unificarLotes(_cpvs, exp.breakdownLot.totalLots, 'cpvs');
      this.unificarLotes(
        _classificationCompany,
        exp.breakdownLot.totalLots,
        'classificationCompany'
      );
      this.unificarLotes(
        _selectionAwardCriteria,
        exp.breakdownLot.totalLots,
        'selectionAwardCriteria'
      );
      this.unificarLotes(
        _partialDeliveries,
        exp.breakdownLot.totalLots,
        'partialPeriod.partialDeliveries'
      );
      this.unificarLotes(
        _unitPrices,
        exp.breakdownLot.totalLots,
        'budget.unitPrice'
      );
      this.unificarLotes(
        _requestedMaterial,
        exp.breakdownLot.totalLots,
        'budget.requestedMaterial'
      );
      this.unificarLotes(
        _tarrif,
        exp.breakdownLot.totalLots,
        'specialEconomicTerm.tariff'
      );
      this.unificarLotes(
        _specialExecutionCondition,
        exp.breakdownLot.totalLots,
        'specialExecutionCondition'
      );
    }
    exp.desglosableInfo.cpvs = _cpvs;
    exp.desglosableInfo.classificationCompany = _classificationCompany;
    exp.desglosableInfo.selectionAwardCriteria = _selectionAwardCriteria;
    exp.desglosableInfo.partialDeliveries = _partialDeliveries;
    exp.desglosableInfo.unitPrice = _unitPrices;
    exp.desglosableInfo.requestedMaterial = _requestedMaterial;
    exp.desglosableInfo.tariff = _tarrif;
    exp.desglosableInfo.specialExecutionCondition = _specialExecutionCondition;
    exp.ui = {};
    exp.ui.listaLotes = this.getListaLotes(exp);
    exp.ui.listaLotesAnualidades = this.getListaLotesAnualidades(exp);
    exp.ui.isModel = this.model;
    exp.listaRelaciones = this.getListaRelacionesAsSecundary(exp);

    this.procurementProjectValidationsIneco.loadData(exp);



  }

  private getListaLotesAnualidades(model: ProcurementProjectDTO): LotDTO[] {

    let elements = [];

    if (model.breakdownLot.lots !== undefined) {
      model.breakdownLot.lots.forEach(item => {
        let lote = new LotDTO();
        lote.lotId = item.lotId;
        lote.lotNumber = item.lotNumber;
        lote.description = item.description;
        elements.push(lote);
      });

      return elements;
    }
  }

  private unificarLotes(
    data: Array<any>,
    lote: ProcurementProjectLotDTO,
    field: string
  ) {
    // inicializar el array si llega nulo
    if (!data) {
      data = [];
    }
    //   exp.breakdownLot.lots.forEach((lote: ProcurementProjectLotDTO) => {
    let elements = this.formService.getNestedProperty(lote, field);
    console.log('comprobando objetos en lote', field, lote, elements);
    if (elements) {
      elements.forEach(item => {
        // comprobamos si el elemento ya existe en la lista
        let itemInList = data.find(itemTmp => {
          console.log(
            'comprobando si el objeto ya existe',
            item.identifier,
            itemTmp.identifier
          );

          return item.identifier === itemTmp.identifier;
        });

        if (!itemInList) {
          // inicializar el array de lotes
          if (!item.listaLotes) {
            item.listaLotes = [];
          }
          // asignar el lote al objeto
          if (lote.lotId !== undefined) {
            const exists = item.listaLotes.some(existingLote => existingLote.lotId === lote.lotId);
            if (!exists) {
              item.listaLotes.push(this.reduceLot(lote));
            }
          }

          data.push(item);
        } else {
          // si ya esta en la lista asociar el lote
          if (lote.lotId !== undefined) {
            const exists = itemInList.listaLotes.some(existingLote => existingLote.lotId === lote.lotId);
            if (!exists) {
              itemInList.listaLotes.push(this.reduceLot(lote));
            }
          }
          //itemInList.listaLotes.push(this.reduceLot(lote));
        }
      });
    }
  }

  reduceLot(lote: ProcurementProjectLotDTO) {
    // Se limpia el resto de datos para evitar referencias circulares
    let _reducedLot = new ProcurementProjectLotDTO();
    (_reducedLot.identifier = lote.identifier),
      (_reducedLot.lotNumber = lote.lotNumber),
      (_reducedLot.lotId = lote.lotId),
      (_reducedLot.description = lote.description);
    return _reducedLot;
  }
  // invocar antes de guardar
  viewModel2DTO() {
    // trabajamos con una copia del objeto
    let tmpExp: any;
    tmpExp = lodash.cloneDeep(this.dossier);

    console.log('antes de limpiar', this.dossier, tmpExp);

    this.desglosarLotes(tmpExp, 'cpvs', 'cpvs');
    /*this.desglosarLotes(
      tmpExp,
      'criteriaTechnicalFinancial',
      'criteriaTechnicalFinancial'
    );*/
    this.desglosarLotes(
      tmpExp,
      'classificationCompany',
      'classificationCompany'
    );
    this.desglosarLotes(
      tmpExp,
      'selectionAwardCriteria',
      'selectionAwardCriteria'
    );
    this.desglosarLotes(
      tmpExp,
      'partialDeliveries',
      'partialPeriod.partialDeliveries'
    );
    this.desglosarLotes(tmpExp, 'unitPrice', 'budget.unitPrice');
    this.desglosarLotes(
      tmpExp,
      'requestedMaterial',
      'budget.requestedMaterial'
    );
    this.desglosarLotes(tmpExp, 'tariff', 'specialEconomicTerm.tariff');

    this.desglosarLotes(
      tmpExp,
      'specialExecutionCondition',
      'specialExecutionCondition'
    );

    // limpiar el temporal
    // delete tmpExp.desglosableInfo;
    tmpExp.desglosableInfo = {};

    //Volver a transformar las relaciones en algo que entienda el DTO


    if (tmpExp.listaRelaciones) {
      for (let i = 0; i <= tmpExp.listaRelaciones.length - 1; i++) {
        if (tmpExp.listaRelaciones[i].secundaryRelation) {
          let relationProject = new ProjectRelationDTO();
          relationProject.relation = new MasterDataDTO('4', 'TIPO_RELACION');
          relationProject.relation.description = 'Está relacionada por';
          relationProject.relationsAsSecundary = new Array<ProjectEntityDTO>();
          relationProject.relationsAsSecundary.push(tmpExp.listaRelaciones[i].secundaryRelation);
          tmpExp.projectRelations['4'] = relationProject;
        }
      }

    }

    /*if (tmpExp.projectRelations !== undefined) {
      let relationProject = tmpExp.projectRelations['4'];
      if (relationProject) {
        relationProject.relationsAsSecundary = [];
        if (tmpExp.listaRelaciones) {
          for (let i = 0; i <= tmpExp.listaRelaciones.length - 1; i++) {
            if (tmpExp.listaRelaciones[i].secundaryRelation) {
              relationProject.relationsAsSecundary.push(tmpExp.listaRelaciones[i].secundaryRelation);
            }

          }
        }
      }

    }*/


    // limpiar variables de apoyo de tablas
    tmpExp = JSON.parse(
      JSON.stringify(tmpExp, (k, v) => (k === '_parent' ? undefined : v))
    );
    console.log('despues de limpiar', this.dossier, tmpExp);
    return tmpExp;
  }

  private desglosarLotes(
    exp: ProcurementProjectDTO,
    fieldDesglose: string,
    field: string
  ) {
    let data: Array<any> = exp.desglosableInfo[fieldDesglose];
    // 1. LIMPIAR LOS DATOS ORIGINALES
    if (exp.breakdownLot.apportioned) {
      if (exp.breakdownLot.lots) {
        exp.breakdownLot.lots.forEach(lote => {
          this.formService.setNestedProperty(lote, field, []);
        });
      }
    } else {
      // MEJORAR ESTO. SI NO HAY DESGLOSE, LOS CPVS DEL LOTE 0 SE RESPETAN PORQUE NO ESTAN EN DESGLOSABLEINFO
      if ('cpvs' === field) {
        return;
      }
      this.formService.setNestedProperty(exp.breakdownLot.totalLots, field, []);
    }

    // 2. VOLCAMOS A LOS LOTES LA INFORMACION DESGLOSADA
    if (data) {
      data.forEach(row => {
        // // limpiar objeto de apoyo para formulario
        delete row['_parent'];
        // si hay desglose de lotes
        if (exp.breakdownLot.apportioned) {
          if (exp.breakdownLot.lots && row.listaLotes) {
            row.listaLotes.forEach(element => {
              let lote = exp.breakdownLot.lots.find(
                lot => lot.identifier === element.identifier
              );
              if (lote) {
                this.addData2Lot(lote, field, row);
              }
            });
          }
        } else {
          // se añadira la informacion al lote zero sino es informacion de lotes borrados anterioremente
          if (row.listaLotes == undefined || row.listaLotes.length == 0) {
            this.addData2Lot(exp.breakdownLot.totalLots, field, row);
          } else {
            let lote =
              row.listaLotes && row.listaLotes.find(lot => lot.lotId === 0);
            if (lote !== undefined) {
              this.addData2Lot(exp.breakdownLot.totalLots, field, row);
            }
          }
        }
        // una vez procesado el objeto, limpiar la lista de lotes
        delete row.listaLotes;
      });
    }
    console.log(
      'COMO HAY DESGLOSE DIVIDISMO LA INFORMACION DE LAS TABLAS POR CADA LOTE',
      exp
    );
  }

  addData2Lot(lote: ProcurementProjectLotDTO, field: string, row: any) {
    let value = this.formService.getNestedProperty(lote, field);
    if (!value) {
      this.formService.setNestedProperty(lote, field, []);
    }

    /*   if (!lote[field]) {
         lote[field] = [];
       }
       */
    // si el item no estaba ya en la lista. ¿Qué pasa si incluyen de nuevo el mismo?
    // ¿Habria que mantener el original?
    let rowFinded = value.find(item => {
      return (
        (row.identifier !== undefined && item.identifier === row.identifier) ||
        (row.rowUuid !== undefined &&
          item.rowUuid !== undefined &&
          item.rowUuid === row.rowUuid)
      );
    });
    if (!rowFinded) {
      value.push(row);
      this.formService.setNestedProperty(lote, field, value);
    }
  }


  changeClassificationCompanySubgroup(model: any, changes?: any) {
    console.log('EJECUTADO changeClassificationCompanySubgroup', model, changes);
    let reset = procurementProjectComponent.resetChange(changes);
    if (reset) {
      // si se cambia el subgrupo hay que resetear la categoria
      let classificationCompany =
        model._parent.desglosableInfo.classificationCompany
          .find(classificationCompany => classificationCompany.subgroup.identifier === changes.newValue.identifier);
      if (classificationCompany) {
        classificationCompany.category = undefined;
      }
    }
  }

  changeClassificationCompanyGroup(model: any, changes?: any) {
    console.log('EJECUTADO changeClassificationCompanyCategory', model, changes);
    let reset = procurementProjectComponent.resetChange(changes);
    if (reset) {
      // si se cambia el grupo hay que resetar el subgrupo y la categoria.
      let classificationCompany = model._parent.desglosableInfo.classificationCompany
        .find(_classificationCompany => _classificationCompany.group.identifier === changes.newValue.identifier);
      if (classificationCompany) {
        classificationCompany.subgroup = undefined;
        classificationCompany.category = undefined;
      }
    }
  }

  changeCompanyToInvite(model: any, changes?: any) {
    console.log('EJECUTADO changeCompanyToInvite', model, changes);
    let reset = procurementProjectComponent.resetChange(changes);
    if (reset) {
      let companytoInvite = model._parent.breakdownLot.totalLots.companyToInvites
        .find(companyToInvite => companyToInvite.company.identifier === changes.newValue.identifier);
      if (companytoInvite && companytoInvite.representative) {
        companytoInvite.representative = undefined;
      }
    }
  }

  loadForms(_index: number): Observable<any> {
    console.log('loadForms');
    let stepDefinition = this.stepDefinition.steps[_index];
    console.log(
      'cambiando de step',
      this.stepDefinition,
      _index,
      this.stepDefinition.steps[_index]
    );
    let _frmConfig = new FormConfig(undefined, stepDefinition.formConfig, this.dossier);
    _frmConfig.showValidations = true;

    _frmConfig.functions.push({
      identifier: 'changeCompanyToInvite',
      fn: this.changeCompanyToInvite
    });

    _frmConfig.functions.push({
      identifier: 'changeClassificationCompanySubgroup',
      fn: this.changeClassificationCompanySubgroup
    });

    _frmConfig.functions.push({
      identifier: 'changeClassificationCompanyGroup',
      fn: this.changeClassificationCompanyGroup
    });
    _frmConfig.functions.push({
      identifier: 'addCriteria',
      fn: this.addCriteria
    });
    _frmConfig.functions.push({
      identifier: 'loadSelectionAwardCriteria',
      fn: this.loadSelectionAwardCriteria
    });

    _frmConfig.functions.push({
      identifier: 'loadDataAMSDA',
      fn: this.loadDataAMSDA
    });

    _frmConfig.functions.push({
      identifier: 'openCPVSelector',
      fn: this.openCPVSelector
    });
    _frmConfig.functions.push({
      identifier: 'openCPVSelector2',
      fn: this.openCPVSelector2
    });
    _frmConfig.functions.push({
      identifier: 'openProjectSelector',
      fn: this.openProjectSelector
    });
    _frmConfig.functions.push({
      identifier: 'newLot',
      fn: this.newLot.bind(this)
    });
    _frmConfig.functions.push({
      identifier: 'removeLot',
      fn: this.removeLot
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleSelectionCriteria',
      fn: this.procurementProjectValidations.isVisibleSelectionCriteria
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleClassificationCompany',
      fn: this.procurementProjectValidations.isVisibleClassificationCompany
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleIncome',
      fn: this.procurementProjectValidations.isVisibleIncome
    });
    _frmConfig.functions.push({
      identifier: 'isvisibleComplementarySystem',
      fn: this.procurementProjectValidations.isvisibleComplementarySystem
    });
    _frmConfig.functions.push({
      identifier: 'valueFullNameRepresentative',
      fn: this.valueFullNameRepresentative
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleSelectionCriteriaAward',
      fn: this.procurementProjectValidations.isVisibleSelectionCriteriaAward
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleSpecialEconomicTerm',
      fn: this.procurementProjectValidations.isVisibleSpecialEconomicTerm
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleSubTypeCode',
      fn: this.procurementProjectValidations.isVisibleSubTypeCode
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleProcessJustificationNegotiated',
      fn: this.procurementProjectValidations
        .isVisibleProcessJustificationNegotiated
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleNoticeDocumentReference',
      fn: this.procurementProjectValidations.isVisibleNoticeDocumentReference
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleCompanyToInvite',
      fn: this.procurementProjectValidations.isVisibleCompanyToInvite
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleCompanyToInviteCBAM',
      fn: this.procurementProjectValidations.isVisibleCompanyToInviteCBAM
    });
    _frmConfig.functions.push({
      identifier: 'clearFromControlCompanyToInvite',
      fn: this.procurementProjectValidations.clearFromControlCompanyToInvite
    });
    _frmConfig.functions.push({
      identifier: 'isBasedFrameworkAgreement',
      fn: this.procurementProjectValidations.isBasedFrameworkAgreement
    });

    _frmConfig.functions.push({
      identifier: 'isVisibleCentralizedPurchases',
      fn: this.procurementProjectValidations.isVisibleCentralizedPurchases
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleCriteriaTechnicalFinancial',
      fn: this.procurementProjectValidations.isVisibleCriteriaTechnicalFinancial
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleLotsPanel',
      fn: this.procurementProjectValidations.isVisibleLotsPanel
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleWorkProgram',
      fn: this.procurementProjectValidations.isVisibleWorkProgram
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleSubcontractTerm',
      fn: this.procurementProjectValidations.isVisibleSubcontractTerm
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleContractExtension',
      fn: this.procurementProjectValidations.isVisibleContractExtension
    });
    _frmConfig.functions.push({
      identifier: 'valueFinalFinancialGuaranteePercentage',
      fn: this.procurementProjectValidations
        .valueFinalFinancialGuaranteePercentage
    });
    _frmConfig.functions.push({
      identifier: 'valueProvisionalGuaranteePercentage',
      fn: this.procurementProjectValidations.valueProvisionalGuaranteePercentage
    });
    _frmConfig.functions.push({
      identifier: 'isVisiblePenaltyClauses',
      fn: this.procurementProjectValidations.isVisiblePenaltyClauses
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleLowTendersDescription',
      fn: this.procurementProjectValidations.isVisibleLowTendersDescription
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleFichCriteriaTechnicalFinancial',
      fn: this.procurementProjectValidations
        .isVisibleFichCriteriaTechnicalFinancial
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleCategory',
      fn: this.procurementProjectValidations.isVisibleCategory
    });
    _frmConfig.functions.push({
      identifier: 'isVisiblePrice',
      fn: this.procurementProjectValidations.isVisiblePrice
    });
    _frmConfig.functions.push({
      identifier: 'isVisiblePriceRevision',
      fn: this.procurementProjectValidations.isVisiblePriceRevision
    });
    _frmConfig.functions.push({
      identifier: 'openRequestMaterial',
      fn: this.openRequestMaterial
    });
    _frmConfig.functions.push({
      identifier: 'valueProvisionalGuarantee',
      fn: this.procurementProjectValidations.valueProvisionalGuarantee
    });
    _frmConfig.functions.push({
      identifier: 'loadCompanyToInvite',
      fn: this.loadCompanyToInvite
    });
    _frmConfig.functions.push({
      identifier: 'loadRequestMaterial',
      fn: this.loadRequestMaterial
    });
    _frmConfig.functions.push({
      identifier: 'isVisiblePriceRevisionWorks',
      fn: this.procurementProjectValidations.isVisiblePriceRevisionWorks
    });
    _frmConfig.functions.push({
      identifier: 'isVisiblePriceRevisionNotWorks',
      fn: this.procurementProjectValidations.isVisiblePriceRevisionNotWorks
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleMethod',
      fn: this.procurementProjectValidations.isVisibleMethod
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleBudgetDeterminationSystem',
      fn: this.procurementProjectValidations.isVisibleBudgetDeterminationSystem
    });
    _frmConfig.functions.push({
      identifier: 'valueBudgetAmountExcludingTaxes',
      fn: this.procurementProjectValidations.valueBudgetAmountExcludingTaxes
    });
    _frmConfig.functions.push({
      identifier: 'enabledAmountExcludingTaxes',
      fn: this.procurementProjectValidations.enabledAmountExcludingTaxes
    });
    _frmConfig.functions.push({
      identifier: 'valueBudgetTotalTaxes',
      fn: this.procurementProjectValidations.valueBudgetTotalTaxes
    });
    _frmConfig.functions.push({
      identifier: 'enabledBudgetTotalTaxes',
      fn: this.procurementProjectValidations.enabledBudgetTotalTaxes
    });
    _frmConfig.functions.push({
      identifier: 'valueBudgetTaxType',
      fn: this.procurementProjectValidations.valueBudgetTaxType
    });
    _frmConfig.functions.push({
      identifier: 'enabledBudgetTaxType',
      fn: this.procurementProjectValidations.enabledBudgetTaxType
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleBudgetAccountLine',
      fn: this.procurementProjectValidations.isVisibleBudgetAccountLine
    });
    _frmConfig.functions.push({
      identifier: 'enabledCofinancing',
      fn: this.procurementProjectValidations.enabledCofinancing
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleCofinancing',
      fn: this.procurementProjectValidations.isVisibleCofinancing
    });
    _frmConfig.functions.push({
      identifier: 'enabledTaxRate',
      fn: this.procurementProjectValidations.enabledTaxRate
    });
    _frmConfig.functions.push({
      identifier: 'valueTaxRate',
      fn: this.procurementProjectValidations.valueTaxRate
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleFrameworkAgreementCriteria',
      fn: this.procurementProjectValidations.isVisibleFrameworkAgreementCriteria
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleHeaderBudgetBreakdown',
      fn: this.procurementProjectValidations.isVisibleHeaderBudgetBreakdown
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleprovisionalGuarantee',
      fn: this.procurementProjectValidations.isVisibleprovisionalGuarantee
    });
    _frmConfig.functions.push({
      identifier: 'isEnabledProcurementCommittee',
      fn: this.procurementProjectValidations.isEnabledProcurementCommittee
    });
    _frmConfig.functions.push({
      identifier: 'valueProcurementCommittee',
      fn: this.procurementProjectValidations.valueProcurementCommittee
    });
    _frmConfig.functions.push({
      identifier: 'visibleFrameworkAgreementCriteria',
      fn: this.procurementProjectValidations.visibleFrameworkAgreementCriteria
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleCriteriaConcretion',
      fn: this.procurementProjectValidations.isVisibleCriteriaConcretion
    });
    _frmConfig.functions.push({
      identifier: 'setDefaultValueFrameworkAgreementCriteria',
      fn: this.setDefaultValueFrameworkAgreementCriteria
    });
    _frmConfig.functions.push({
      identifier: 'setContractBasedFrameworkAgreement',
      fn: this.setContractBasedFrameworkAgreement
    });
    _frmConfig.functions.push({
      identifier: 'isActiveBaseContractNoRelated',
      fn: this.isActiveBaseContractNoRelated
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleBaseContractNoRelated',
      fn: this.procurementProjectValidations.isVisibleBaseContractNoRelated
    });
    _frmConfig.functions.push({
      identifier: 'isEnabledTenderBasedFrameworkAgreement',
      fn: this.isEnabledTenderBasedFrameworkAgreement
    });
    _frmConfig.functions.push({
      identifier: 'isEnabledFrameworkAgreementCriteria',
      fn: this.procurementProjectValidations.isEnabledFrameworkAgreementCriteria
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleProcurementCommittee',
      fn: this.procurementProjectValidations.isVisibleProcurementCommittee
    });
    _frmConfig.functions.push({
      identifier: 'isActiveBaseContractRelated',
      fn: this.procurementProjectValidations.isActiveBaseContractRelated
    });
    _frmConfig.functions.push({
      identifier: 'visibleRequestedMaterial_CBAM_CSDA',
      fn: this.procurementProjectValidations.visibleRequestedMaterial_CBAM_CSDA
    });
    // Funciones para Gobernanza
    _frmConfig.functions.push({
      identifier: 'valueEUDirective',
      fn: this.valueEUDirective
    });
    _frmConfig.functions.push({
      identifier: 'valueNumLicitableLots',
      fn: this.valueNumLicitableLots
    });
    _frmConfig.functions.push({
      identifier: 'editableNumLicitableLots',
      fn: this.procurementProjectValidations.editableNumLicitableLots
    });
    _frmConfig.functions.push({
      identifier: 'isEnabledContractFolderId',
      fn: this.procurementProjectValidations.isEnabledContractFolderId
    });
    _frmConfig.functions.push({
      identifier: 'valueConfidentialityPeriod',
      fn: this.valueConfidentialityPeriod
    });
    _frmConfig.functions.push({
      identifier: 'isCatalogProcurementProject',
      fn: this.procurementProjectValidations.isCatalogProcurementProject
    });
    _frmConfig.functions.push({
      identifier: 'valueTotalAmount',
      fn: this.procurementProjectValidations.valueTotalAmount
    });
    _frmConfig.functions.push({
      identifier: 'isApplicableLegislationLCSP_RDL_3_20',
      fn: ProcurementProjectValidations.isApplicableLegislationLCSP_RDL_3_20
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleNoticeDocumentReferenceRDL_3_20',
      fn: this.procurementProjectValidations.isVisibleNoticeDocumentReferenceRDL_3_20
    });
    _frmConfig.functions.push({
      identifier: 'isVisiblePenaltyClausesOther',
      fn: this.procurementProjectValidations.isVisiblePenaltyClausesOther
    });
    _frmConfig.functions.push({
      identifier: 'clearLotTotalTaxes',
      fn: this.clearLotTotalTaxes
    });
    _frmConfig.functions.push({
      identifier: 'SUEZopenActionImportCompany',
      fn: this.SUEZopenActionImportCompany
    });
    _frmConfig.functions.push({
      identifier: 'valueTotalAmounLot',
      fn: this.procurementProjectValidations.valueTotalAmounLot
    });

    // FUNCIONES ASOCIADAS A LOS MODOS --------------------------------
    _frmConfig.functions.push({
      identifier: 'isMinorContractMode',
      fn: this.procurementProjectValidations.isMinorContractMode
    });
    _frmConfig.functions.push({
      identifier: 'isOpenContractMode',
      fn: this.procurementProjectValidations.isOpenContractMode
    });
    _frmConfig.functions.push({
      identifier: 'isNegotiatedMode',
      fn: this.procurementProjectValidations.isNegotiatedMode
    });
    _frmConfig.functions.push({
      identifier: 'isRestrictedMode',
      fn: this.procurementProjectValidations.isRestrictedMode
    });
    _frmConfig.functions.push({
      identifier: 'isBasedFrameworkAgreementMode',
      fn: this.procurementProjectValidations.isBasedFrameworkAgreementMode
    });
    _frmConfig.functions.push({
      identifier: 'isCompetitiveDialogueMode',
      fn: this.procurementProjectValidations.isCompetitiveDialogueMode
    });
    _frmConfig.functions.push({
      identifier: 'isCentralizedPurchases',
      fn: this.procurementProjectValidations.isCentralizedPurchases
    });
    // FUNCION DE BSM. Quitar cuando se adaptar los componentes.
    _frmConfig.functions.push({
      identifier: 'valueManagementCompany',
      fn: this.procurementProjectValidations.valueManagementCompany
    });
    _frmConfig.functions.push({
      identifier: 'editableManagementCompany',
      fn: this.procurementProjectValidations.editableManagementCompany
    });
    // Indica si esta habilitado el Modo de Tramit.
    _frmConfig.functions.push({
      identifier: 'isEnabledProcessingMode',
      fn: this.procurementProjectValidations.isEnabledProcessingMode
    });
    // FIN FUNCIONES ASOCIADAS A LOS MODOS -----------------
    // FUNCIONES UVAL
    _frmConfig.functions.push({
      identifier: 'UVAL_clearBudgetAccountLines',
      fn: this.UVAL_clearBudgetAccountLines
    });
    _frmConfig.functions.push({
      identifier: 'valueSubmissionPlatform',
      fn: this.valueSubmissionPlatform
    });
    // FUNCIONES EFORMS B2B
    _frmConfig.functions.push({
      identifier: 'isVisibleProcedureCharacteristics',
      fn: this.procurementProjectValidations.isVisibleProcedureCharacteristics
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleFinancialConditions',
      fn: this.procurementProjectValidations.isVisibleFinancialConditions
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleAgreementPublicProcurement',
      fn: this.procurementProjectValidations.isVisibleAgreementPublicProcurement
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleTendererLegalForm',
      fn: this.procurementProjectValidations.isVisibleTendererLegalForm
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleUnnecessaryNegotiation',
      fn: this.procurementProjectValidations.isVisibleUnnecessaryNegotiation
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleNumMaxContractExt',
      fn: this.procurementProjectValidations.isVisibleNumMaxContractExt
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleExclusionReason',
      fn: this.procurementProjectValidations.isVisibleExclusionReason
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleCleanVehicleDirective',
      fn: this.procurementProjectValidations.isVisibleCleanVehicleDirective
    });
    _frmConfig.functions.push({
      identifier: 'isVisibleNonElectronicTenderReason',
      fn: this.procurementProjectValidations.isVisibleNonElectronicTenderReason
    });

    _frmConfig.functions.push({
      identifier: 'isVisibleProjectRelated',
      fn: this.procurementProjectValidations.isVisibleProjectRelated
    });
    _frmConfig.functions.push({
      identifier: 'valueChangeExpRel',
      fn: this.valueChangeExpRel
    });
    _frmConfig.functions.push({
      identifier: 'isEnabledActiveProjects',
      fn: this.procurementProjectValidations.isEnabledActiveProjects
    });
    _frmConfig.functions.push({
      identifier: 'isEnabledActiveProjectsTable',
      fn: this.procurementProjectValidations.isEnabledActiveProjectsTable
    });
    _frmConfig.functions.push({
      identifier: 'setLabelSpecialServices',
      fn: this.setLabelSpecialServices.bind(this)
    });
    //Función específica de INECO
    _frmConfig.functions.push({
      identifier: 'changeProjectCode',
      fn: this.procurementProjectValidationsIneco.changeProjectCode
    });
    _frmConfig.functions.push({
      identifier: 'loadData',
      fn: this.procurementProjectValidationsIneco.loadData
    });
    try {
      _frmConfig = FE(_frmConfig, this);
    } catch (err) {
      console.log('*****> No existe adaptación de funciones de la FE.');
      console.warn(err);
      console.log('<***** No existe adaptación de funciones de la FE.');

    }

    this.formContainer.clear();
    if (this.readonly) {
      _frmConfig.readonly = true;
    }


    const childComponent = this.componentFactoryResolver.resolveComponentFactory(
      formPlycaComponent
    );
    this.waitService.startWaiting();
    this.form = this.formContainer.createComponent(childComponent).instance;
    this.form.manageWaitService = false;

    this.form['formConfig'] = _frmConfig;


    return this.form.getCompleted();


  }

  saveAction() {

    // this.loading.next(new LoadingInfo(true));
    this.waitService.startWaiting();
    this.subscribe(this.save().pipe(finalize(() => {
      this.waitService.cancelWaiting();
      this.loaded = true;
    })),
      data => {

        // this.loading.next(new LoadingInfo(false));
        if (this.task && !this.isStatelessTask()) {
          let stepCurrent = this.getCurrentStep();
          if (stepCurrent.lastStep && data.isValidatedOk) {
            this.waitService.startWaiting('Procesando los datos de la tarea ...');
            this.procesandoTarea = true;
            this.processTask();
          }
        }
      }
    );
  }

  private getContext(existIdentifier: boolean, nextStep?: boolean) {
    let validationContext;
    if (existIdentifier) {
      validationContext = 'Update';
    } else {
      validationContext = 'Insert';
    }

    // si hay definido un grupo de validaciones asociado al paso  prevalece sobre la definición de validación asociado al formulario
    // si hay definido un grupo de validaciones a la definición de formulario se especifica

    let stepCurrent = this.getCurrentStep();

    if (nextStep !== undefined && nextStep != null) {
      if (nextStep) {
        stepCurrent = this.stepDefinition.steps.find(t => t.value === 1);
      } else {
        stepCurrent = this.stepDefinition.steps.find(t => t.value === 0);
      }
    }

    if (
      stepCurrent.validationsGroup === undefined &&
      this.stepDefinition.validationsGroup
    ) {
      validationContext += this.stepDefinition.validationsGroup;
    } else if (stepCurrent.validationsGroup) {
      validationContext += stepCurrent.validationsGroup;
    }

    if (this.model) {
      validationContext += '_Model';
    }
    return validationContext;

  }

  save(newStep?: number): Observable<SaveDossierData> {
    this.waitService.startWaiting(this.translate.instant('GenericDossier.validate.validating'));

    // Se establce el listadocid en el caso que sea un modelo

    if (!this.dossier.documentClass) {
      if (this.model) {
        this.dossier.documentClass = {
          identifier: this.appConfig.getValue('dossierModel.documentClass'),
          abbreviation: 'EXPMODELO'
        } as DocumentClassDTO;
      } else {
        this.dossier.documentClass = {
          identifier: '00000'
        } as DocumentClassDTO;
      }
    }
    // VALIDATE -->
    let model = this.viewModel2DTO();
    let validationContext = 'procurementProjects/validations/';

    // Si hay definido un grupo de validaciones asociado al paso  prevalece sobre la definición de validación

    let validationContextGroupValidation: string;

    // Si se ha pulsado el botón de Cambio de Paso
    if (newStep !== undefined && newStep != null) {
      if (newStep == 1) {
        validationContextGroupValidation = this.getContext(
          model.identifier !== undefined ? true : false, true);
      } else {
        validationContextGroupValidation = this.getContext(
          model.identifier !== undefined ? true : false, false);
      }
      // Si se ha pulsado el botón de "Grabar"
    } else {
      validationContextGroupValidation = this.getContext(
        model.identifier !== undefined ? true : false, undefined);
    }

    if (validationContextGroupValidation) {
      validationContext += validationContextGroupValidation;
    }

    console.log(
      'VALIDANDO MODELO',
      model,
      ' con el grupo de validaciones ',
      validationContext
    );
    // Se validan los campos
    return this.getValidateObservable(validationContext, model, true, newStep !== undefined).pipe(
      flatMap(validations => {


        // Se muestran los errores de validación
        console.log('Validación completada.');

        let validationErrors: boolean =
          validations.body.errors && validations.body.errors.filter(error => error.result !== 'WARNING').length > 0;

        // Se guardan los datos del expediente y se muestra el diálog de espera de actualización
        let config: DynamicDialogConfig = {
          header: '',
          closeOnEscape: false,
          showHeader: false,
          width: '50%',
          style: { overflow: 'scroll', 'max-height': '80%' }
        };
        config['dossier'] = this.viewModel2DTO();
        config['task'] = this.task;
        config['validationContext'] = this.getContext(
          config['dossier'].identifier !== undefined ? true : false
        );

        let stepCurrent = this.getCurrentStep();
        config['lastStep'] = stepCurrent.lastStep;
        if (newStep !== undefined && stepCurrent.value !== newStep) {
          config['stepChange'] = true;
        }



        const ref = this.dialogService.open(saveDossierPopupComponent, config);

        return ref.onClose.pipe(
          this.onClosePopup(validationErrors, newStep, validationContext),

          finalize(() => {
            this.loaded = true;
            this.waitService.cancelWaiting();
          }));

        // <-- VALIDATE
      }));
  }

  private onClosePopup(validationErrors: boolean, newStep: number, validationContext: string) {
    return map((data: SaveDossierData) => {

      if (data.popupReturnAction === 'TRAMITACIONOK') {
        this.TRAMITACIONOK = true;
        this.waitService.cancelWaiting();
        this.router.navigate(['/dossierInfo/' + data.dossier.identifier]);
      } else {
        // this.waitService.startWaiting('Actualizando el formulario ...');
        // this.loading.next(new LoadingInfo(false));

        if (data) {
          data.isValidatedOk = !validationErrors;
          if (data.error) {
            console.log('SAVEDATA DEVUELVE ERROR', data.error);
            // Si hay errores de tipo FATAL, se muestrab
            this.waitService.cancelWaiting();
            this.uiService.showSuccess(this.translate.instant('ProcurementProject.saving.error'),
              this.translate.instant('General.warning'));
            this.form.manageFormException(data.error);
            return data;
          } else {
            console.log('SAVEDATA CORRECTO. ACTUALIZANDO DOSSIER', data.dossier);
            // Si no habido errores se ha grabadi correctamente, se actualiza el paso
            if (newStep !== undefined) {
              this.currentStep = newStep;
            }
            // Se recargan los datos del formulario de la ficha
            this.subscribe(this.processDossierForm(data.dossier),
              (ok) => {
                if (ok) {
                  this.form.validate(validationContext, this.viewModel2DTO());
                  console.log('Componente cargado');
                  if (!this.procesandoTarea) {
                    this.waitService.cancelWaiting();
                  }
                  this.uiService.showSuccess(data.message, this.translate.instant('General.info'), 'success');
                }
              }
            );
            return data;
          }
        }
      }

    });
  }

  public getDossierId(dossier: ProcurementProjectDTO): string {
    // return dossier.name ? dossier.name : this.getPropuestaId(dossier);
    return dossier.description
      ? dossier.description
      : this.getPropuestaId(dossier);
  }

  private getPropuestaId(dossier: ProcurementProjectDTO): string {
    let propuesta = dossier.identifier;
    if (propuesta && propuesta.length > 4) {
      propuesta = propuesta.substring(0, 4) + '/' + propuesta.substring(4);
    }
    return propuesta;
  }

  // Metodo antiguo de cargar material solicitado desde botón
  // Pendiente de utilizar, futuros desarrollos
  public loadRequestMaterialOld(model: any): Observable<RequestMaterialDTO[]> {
    if (
      model.contractingSystem &&
      model.contractingSystem.originalContractingSystemID &&
      model.contractingSystem.originalContractingSystemID.contractFolderId
    ) {
      // se recuperan los lotes adjudicados del expediente base
      let contractFolderId =
        model.contractingSystem.originalContractingSystemID.contractFolderId;
      let loteId = null;
      if (model.contractingSystem.originalContractingSystemLotID) {
        loteId = model.contractingSystem.originalContractingSystemLotID.lotId;
      } else {

        // Si no tiene categoria, porque no la ha seleccionado
        // o el Acuerdo Marco Padre no tiene lotes, en ese caso loteid=0
        if (model.procurementProjectAM.breakdownLot.apportioned == false) {
          loteId = 0;
        }
      }

      let config: DynamicDialogConfig = {
        header: this.translationService.instant(
          'ProcurementProjectLot.titleSelLotAM'

        ),
        width: '70%',
        style: { overflow: 'scroll', 'max-height': '80%' },
        styleClass: 'searchStyle'
      };
      config['contractFolderId'] = contractFolderId;
      config['origin'] = 'requestMaterial';
      config['lotId'] = loteId;

      const ref = this.dialogService.open(
        SearchLotsAwardsPopupComponent,
        config
      );

      return ref.onClose.pipe(
        // tap: es haz algo y devuelve lo que ha devuelto la ventana
        // map: transforma el resultado de la ventana entrando un observable y devolviendolo a otro observable
        flatMap((numLot: number) => {

          if (numLot) {
            let procurementProjectUrl =
              this.configuration.REQUEST_MATERIAL_SERVICE_URL +
              '?contractFolderId=' +
              contractFolderId +
              '&lotId=' +
              numLot;
            let resultQuery = this.plycaService.query<RequestMaterialDTO>(
              procurementProjectUrl
            );
            return resultQuery;

          }

          return of();
        }), // fin map numLot
        map((pageRequestedMaterial: PaginationDTO<RequestMaterialDTO>) => {
          if (pageRequestedMaterial) {
            pageRequestedMaterial.content.forEach(
              material => (material.lot = null)
            );
            return pageRequestedMaterial.content;
          }
          return [];
        }) // fin map pageRequestedMaterial
      );
    } else {
      this.uiService.showMessage(
        this.translationService.instant(
          'ProcurementProjectLot.contractFolderIdCBAMRequiredRequestMaterial'
        )
      );
      return of();
    }
  }


  public loadRequestMaterial(model: any): Observable<RequestMaterialDTO[]> {
    if (
      model.contractingSystem &&
      model.contractingSystem.originalContractingSystemID &&
      model.contractingSystem.originalContractingSystemID.contractFolderId
    ) {
      // se recuperan los lotes adjudicados del expediente base
      let contractFolderId =
        model.contractingSystem.originalContractingSystemID.contractFolderId;
      let loteId = null;
      if (model.contractingSystem.originalContractingSystemLotID) {
        loteId = model.contractingSystem.originalContractingSystemLotID.lotId;
      } else {

        // Si no tiene categoria, porque no la ha seleccionado
        // o el Acuerdo Marco Padre no tiene lotes, en ese caso loteid=0
        if (model.procurementProjectAM.breakdownLot.apportioned == false) {
          loteId = 0;
        }
      }

      let config: DynamicDialogConfig = {
        header: this.translationService.instant(
          'ProcurementProjectLot.titleSelLotAM'

        ),
        width: '70%',
        style: { overflow: 'scroll', 'max-height': '80%' },
        styleClass: 'searchStyle'
      };
      config['contractFolderId'] = contractFolderId;
      config['origin'] = 'requestMaterial';
      config['lotId'] = loteId;

      const ref = this.dialogService.open(
        SearchLotsAwardsPopupComponent,
        config
      );

      this.subscribe(ref.onClose.pipe(
        // tap: es haz algo y devuelve lo que ha devuelto la ventana
        // map: transforma el resultado de la ventana entrando un observable y devolviendolo a otro observable
        flatMap((numLot: number) => {

          if (numLot) {
            let procurementProjectUrl =
              this.configuration.REQUEST_MATERIAL_SERVICE_URL +
              '?contractFolderId=' +
              contractFolderId +
              '&lotId=' +
              numLot;
            let resultQuery = this.plycaService.query<RequestMaterialDTO>(
              procurementProjectUrl
            );
            return resultQuery;

          }

          return of();
        }), // fin map numLot
        map((pageRequestedMaterial: PaginationDTO<RequestMaterialDTO>) => {
          if (pageRequestedMaterial) {
            let requestedMaterials = pageRequestedMaterial.content;
            let _this = this as unknown as formElementComponent;
            if (requestedMaterials) {
              requestedMaterials.forEach((requestedMaterial: RequestMaterialDTO) => {
                // generar objeto company
                let material = new RequestMaterialDTO();
                material = requestedMaterial;
                material.lot = null;
                _this._addRow(material);
              });
            }
          } else {
            this.uiService.showMessage(
              this.translationService.instant(
                'ProcurementProjectLot.notExistRequestedMaterial'
              )
            );
          }
        }) // fin map pageRequestedMaterial
      ));
    } else {
      this.uiService.showMessage(
        this.translationService.instant(
          'ProcurementProjectLot.contractFolderIdCBAMRequiredRequestMaterial'
        )
      );
      return of();
    }
  }


  public loadSelectionAwardCriteria(model: any) {
    if (
      model.contractingSystem &&
      model.contractingSystem.originalContractingSystemID
    ) {
      let contractFolderId =
        model.contractingSystem.originalContractingSystemID.contractFolderId;
      let categoria = model.contractingSystem.originalContractingSystemLotID;
      if (contractFolderId && categoria) {
        // buscar el lote para el expedienteId
        let procurementProjectUrl =
          this.configuration.PROCUREMENTPROJLOT_ONLY_SERVICE_ACTION +
          '?contractFolderId=' +
          contractFolderId +
          '&lotId=' +
          categoria.lotId +
          '&expand=expansionSet:basic_criteria';
        this.subscribe(this.plycaService
          .query<ProcurementProjectLotDTO>(procurementProjectUrl)
          ,
          (result: PaginationDTO<ProcurementProjectLotDTO>) => {
            if (
              result &&
              result.content
            ) {
              // se muestra un mensaje al usuario especificando que si desea cargar los criterios
              let confirmMessage = this.translationService.instant(
                'ProcurementProjectLot.loadCriterialAM'
              );
              this.uiService.showConfirmMessage({
                message: confirmMessage,
                header: 'Confirmation',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                  model.breakdownLot.totalLots.selectionAwardCriteria = [];
                  if (model.desglosableInfo['selectionAwardCriteria']) {
                    model.desglosableInfo['selectionAwardCriteria'] = [];
                  }
                  result.content
                    .filter((lot: ProcurementProjectLotDTO) => lot.selectionAwardCriteria && lot.selectionAwardCriteria.length > 0
                    ).forEach((lot: ProcurementProjectLotDTO) => lot.selectionAwardCriteria.forEach(
                      (criteria: CriteriaDTO) => {
                        criteria.identifier = undefined;
                        model.desglosableInfo['selectionAwardCriteria'].push(
                          criteria
                        );
                      }
                    ));
                },
                reject: () => {
                  console.log('NO SE CARGAN LOS CRITERIOS');
                }
              });
            }
          },
          (error: any) => this.plycaErrorHandler.showServerError(error)
        );
      }
    }
    return model;
  }


  public loadCompanyToInvite(
    model: any
  ): Observable<Array<CompanyToInviteDTO>> {
    if (
      model.contractingSystem &&
      model.contractingSystem.originalContractingSystemID &&
      model.contractingSystem.originalContractingSystemID.contractFolderId
    ) {
      // se recuperan los lotes adjudicados del expediente base
      let contractFolderId =
        model.contractingSystem.originalContractingSystemID.contractFolderId;
      let loteId = null;
      if (model.contractingSystem.originalContractingSystemLotID) {
        loteId = model.contractingSystem.originalContractingSystemLotID.lotId;
      } else {
        if (model.procurementProjectAM.breakdownLot.apportioned == false) {
          loteId = 0;
        }
      }

      let config: DynamicDialogConfig = {
        header: this.translationService.instant(
          'ProcurementProjectLot.titleSelLotAM'
        ),
        width: '70%',
        style: { overflow: 'scroll', 'max-height': '80%' },
        styleClass: 'searchStyle'
      };
      config['contractFolderId'] = contractFolderId;
      config['origin'] = 'companyToInvite';
      config['lotId'] = loteId;

      const ref = this.dialogService.open(
        SearchLotsAwardsPopupComponent,
        config
      );
      let companiesToInvites = new Array<CompanyToInviteDTO>();

      this.subscribe(ref.onClose.pipe(
        flatMap((numLot: number) => {
          // consultamos la adjudicacion del lote
          if (numLot != undefined && loteId === 0) {// Acuerdos Marco sin Lotes
            let procurementProjectUrl =
              this.configuration.AWARD_SERVICE_URL +
              '?contractFolderId=' +
              contractFolderId;
            return this.plycaService.query<AwardDTO>(procurementProjectUrl);
          } else {
            if (numLot) {
              let procurementProjectUrl =
                this.configuration.AWARD_SERVICE_URL +
                '?contractFolderId=' +
                contractFolderId +
                '&lotsId=' +
                numLot +
                '&expand=expansionset:lotscompany';
              return this.plycaService.query<AwardDTO>(procurementProjectUrl);
            }
          }
          return of();
        }),
        map((resultAdjudicaciones: PaginationDTO<AwardDTO>) => {
          if (resultAdjudicaciones) {
            let awards: AwardDTO[];
            // devolvemos la adjudicacion del lote
            awards = resultAdjudicaciones.content;
            let _this = this as unknown as formElementComponent;
            if (awards) {
              awards.forEach((award: AwardDTO) => {
                // generar objeto company
                let companyToInvite = new CompanyToInviteDTO();
                companyToInvite.company = award.company;
                _this._addRow(companyToInvite);
              });
            }
          } else {
            // Se elimina en el caso de que haya precargadas antes
            model.breakdownLot.totalLots.companyToInvites = [];
            /*this.uiService.showMessage(
              this.plycaService.getServiceErrorMessage(
                this.translationService.instant(
                  'ProcurementProjectLot.notExistCompanyToInvite'
                )
              )
            );*/
          }
        }),
        catchError((error: any) => {
          this.plycaErrorHandler.showServerError(error);
          return throwError(error);
        })));
    } else {
      this.uiService.showMessage(
        this.translationService.instant(
          'ProcurementProjectLot.contractFolderIdCBAMRequired'
        )
      );
      return of();
    }
  }

  // Metodo antiguo de cargar empresas a invitar desde botón
  // Pendiente de utilizar, futuros desarrollos
  public loadCompanyToInviteOld(
    model: any
  ): Observable<Array<CompanyToInviteDTO>> {
    if (
      model.contractingSystem &&
      model.contractingSystem.originalContractingSystemID &&
      model.contractingSystem.originalContractingSystemID.contractFolderId
    ) {
      // se recuperan los lotes adjudicados del expediente base
      let contractFolderId =
        model.contractingSystem.originalContractingSystemID.contractFolderId;
      let loteId = null;
      if (model.contractingSystem.originalContractingSystemLotID) {
        loteId = model.contractingSystem.originalContractingSystemLotID.lotId;
      } else {
        if (model.procurementProjectAM.breakdownLot.apportioned == false) {
          loteId = 0;
        }
      }

      let config: DynamicDialogConfig = {
        header: this.translationService.instant(
          'ProcurementProjectLot.titleSelLotAM'
        ),
        width: '70%',
        style: { overflow: 'scroll', 'max-height': '80%' },
        styleClass: 'searchStyle'
      };
      config['contractFolderId'] = contractFolderId;
      config['origin'] = 'companyToInvite';
      config['lotId'] = loteId;

      const ref = this.dialogService.open(
        SearchLotsAwardsPopupComponent,
        config
      );
      let companiesToInvites = new Array<CompanyToInviteDTO>();

      return ref.onClose.pipe(
        flatMap((numLot: number) => {
          // consultamos la adjudicacion del lote
          if (numLot != undefined && loteId === 0) {// Acuerdos Marco sin Lotes
            let procurementProjectUrl =
              this.configuration.AWARD_SERVICE_URL +
              '?contractFolderId=' +
              contractFolderId;
            return this.plycaService.query<AwardDTO>(procurementProjectUrl);
          } else {
            if (numLot) {
              let procurementProjectUrl =
                this.configuration.AWARD_SERVICE_URL +
                '?contractFolderId=' +
                contractFolderId +
                '&lotsId=' +
                numLot +
                '&expand=expansionset:lotscompany';
              return this.plycaService.query<AwardDTO>(procurementProjectUrl);
            }
          }
          return of();
        }),
        map((resultAdjudicaciones: PaginationDTO<AwardDTO>) => {
          if (resultAdjudicaciones) {
            // devolvemos la adjudicacion del lote
            return resultAdjudicaciones.content;
          }
          // se resetea las empresas a invitar que hubiera antes para cargarlas solo con la información que se devuelva
          // model.breakdownLot.totalLots.companyToInvites = [];
          return undefined;
        }),
        map((awards: AwardDTO[]) => {
          if (awards) {
            awards.forEach((award: AwardDTO) => {
              // generar objeto company
              let companyToInvite = new CompanyToInviteDTO();
              companyToInvite.company = award.company;
              companiesToInvites.push(companyToInvite);
            });
            return companiesToInvites;
          }
          return undefined;
        }),
        catchError((error: any) => {
          this.plycaErrorHandler.showServerError(error);
          return throwError(error);
        })
      );
    } else {
      this.uiService.showMessage(
        this.translationService.instant(
          'ProcurementProjectLot.contractFolderIdCBAMRequired'
        )
      );
      return of();
    }
  }

  public openRequestMaterial(model: any) {
    return model.contractingSystem.originalContractingSystemID
      .requestedMaterial;
  }
  openCPVSelector() {
    let contextSearch = new SearchSettingDTOModal('', true);
    let config: DynamicDialogConfig = {
      header: '',
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' }
    };
    config['context'] = contextSearch;
    this.waitService.startWaiting();
    let ref = this.dialogService.open(searchCPVComponent, config);
    return ref.onClose;
  }

  public openProjectSelector() {
    let contextSearch = new SearchSettingDTOModal('ProcurementProject', true);
    let config: DynamicDialogConfig = {
      header: '',
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' }
    };
    config['context'] = contextSearch;
    let ref = this.dialogService.open(searchGenericComponent, config);
    this.subscribe(ref.onClose, documentClass => {
      let _this = this as unknown as formElementComponent;
      _this._addRow(documentClass);
    });
  }

  openCPVSelector2() {
    let contextSearch = new SearchSettingDTOModal('', true);
    let config: DynamicDialogConfig = {
      header: '',
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' }
    };
    config['context'] = contextSearch;
    this.waitService.startWaiting();
    let ref = this.dialogService.open(searchCPVComponent, config);
    this.subscribe(ref.onClose, cpv => {
      let _this = this as unknown as formElementComponent;
      _this._addRow(cpv);
    });
  }

  newLot(model: any) {
    //    return new Promise(resolve => {
    //    return defer(() => {
    console.log('invocacion a newLot', model);
    let nuevoLote;
    if (!model) {
      nuevoLote = lodash.cloneDeep(model);
    } else {
      nuevoLote = new ProcurementProjectLotDTO();
    }
    nuevoLote.identifier = '' + generateRandomIdentifier();
    let lotNumber = 1;
    if (
      this.dossier &&
      this.dossier.breakdownLot &&
      this.dossier.breakdownLot.lots &&
      this.dossier.breakdownLot.lots.length > 0
    ) {
      lotNumber = this.dossier.breakdownLot.lots.length + 1;
    }
    nuevoLote.lotNumber = lotNumber;
    nuevoLote.description = 'Lote ' + nuevoLote.lotNumber;
    //      return of(nuevoLote);
    return nuevoLote;
    //    });
  }
  removeLot(lot2Remove: ProcurementProjectLotDTO) {
    return new Promise(resolve => {
      // dossier.desglosableInfo;
      console.log('ELIMINANDO LOTE!!!!!!', lot2Remove);
      resolve(true);
    });
  }

  addCriteria() {
    let config: DynamicDialogConfig = {
      header: 'Criterios de adjudicación',
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' },
      styleClass: 'searchStyle'
    };
    config['context'] = new SearchSettingDTOModal('CRITERIOS_DEFINICION_MODELO');
    const ref = this.dialogService.open(searchGenericComponent, config);
    this.subscribe(ref.onClose, (criteria: CriteriaDefDTO) => {
      if (criteria) {
        // obtener referencia al formelement que invoca para poder utilizar el metodo _addRow
        let _this = this as unknown as formElementComponent;
        let newRow: CriteriaDTO = new CriteriaDTO();
        newRow.name = criteria.name;
        newRow.description = criteria.description;
        newRow.awardingCriteriaTypeCode = criteria.awardingCriteriaTypeCode;
        _this._addRow(newRow);
      }
    });
  }

  // Esta funcion de momento no se utiliza es para añadir filas vacías a la tabla de Empresas a Invitar
  addCompanyToInvite() {
    let _this = this as unknown as formElementComponent;
    let newRow: CompanyToInviteDTO = new CompanyToInviteDTO();
    _this._addRow(newRow);
  }

  validate() {
    let model = this.viewModel2DTO();
    let validationContext = 'procurementProjects/validations/';

    // si hay definido un grupo de validaciones asociado al paso  prevalece sobre la definición de validación asociado al formulario
    // si hay definido un grupo de validaciones a la definición de formulario se especifica

    let validationContextGroupValidation = this.getContext(
      model.identifier !== undefined ? true : false
    );
    if (validationContextGroupValidation) {
      validationContext += validationContextGroupValidation;
    }
    console.log(
      'VALIDANDO MODELO',
      model,
      ' con el grupo de validaciones ',
      validationContext
    );
    this.form.deleteFormErrors();
    this.subscribe(this.getValidateObservable(validationContext, model), () => {
      // this.saveAction();
      console.log('Validación completada.');
    });

  }


  private cancel() {

    if (this.model) {
      this.router.navigate(['/dossierModels/']);
    } else if (this.form.formGroup.controls.identifier.value) {
      this.router.navigate(['/dossierInfo/' + this.form.formGroup.controls.identifier.value]);
      // this.uiService.routeBack();
    } else {
      this.router.navigate(['/mainView/']);
    }

  }



  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.authService.isLoggedIn()) {
      return true;
    } else if (!this.selectStepMode) {
      if (this.task) {
        if (this.TRAMITACIONOK) {
          this.waitService.startWaiting();
          this.subscribe(this.taskService
            .dispatchTask(this.task).pipe(finalize(() => {

              this.waitService.cancelWaiting();

            })));
          return true;
        } else {
          return super.canDeactivate();
        }

        /*

        let resultTaskCanDeactivate = super.canDeactivate();

        if (resultTaskCanDeactivate instanceof Promise) {
          console.log('EL canDeactivate DEVUELVE UNA PROMESA');
          resultTaskCanDeactivate.then(
            result => {
              console.log('PROCESANDO  (PROMISE)');
              return new Promise(resolve => {
                resolve(result);
              });
            },
            () => 'Rejected!'
          );
        } else if (resultTaskCanDeactivate instanceof Observable) {
          console.log('EL resultTaskCanDeactivate DEVUELVE UN OBSERVABLE');
          resultTaskCanDeactivate.subscribe(result => {
            return new Promise(resolve => {
              resolve(result);
            });
          });
        } else {
          return resultTaskCanDeactivate;
        }


        */
      } else {
        // Si no hay tarea y el expediente se ha tramitado
        // o tiene disponible la acción tramitar,
        // no se pregunta al salir

        if (this.isProjectStartEnabled() || this.TRAMITACIONOK) {
          return new Promise(resolve => {
            resolve(true);
          });
        } else {
          // Si la pantalla está en solo lectura no se muestra el mensaje, si desea descartar cambios
          if (!this.readonly) {
            return new Promise(resolve => {
              this.confirmationService.confirm({
                message: this.translate.instant('General.discard.changes'),
                acceptLabel: this.translationService.instant('General.discard.accept'),
                rejectLabel: this.translationService.instant('General.discard.cancel'),
                key: 'procurementProjectConfirmDialog',
                accept: () => resolve(true),
                reject: () => resolve(false)

              });
            }

            );
          } else {
            return new Promise(resolve => {
              resolve(true);
            });
          }
        }
      }
    } else {
      return true;
    }
  }

  volver() {
    this.uiService.routeBack()
  }

  isProjectStartEnabled(): boolean {
    // solamente se habilita la opcion de tramitar si es el ultimo paso
    let stepCurrent = this.getCurrentStep();
    return (
      this.dossier &&
      stepCurrent.lastStep &&
      this.getStartProjectAction() != undefined
    );
  }

  private getStartProjectAction(): ActionDTO {
    let startAction: ActionDTO;
    let dossier = this.dossier;
    let actions = dossier.availableActions;
    if (actions) {
      startAction = dossier.availableActions.actions.find(
        (action: ActionDTO) =>
          action.identifier === 'PROJECT_START' && action.enabled
      );
      this.dossier.availableActions = actions;
    }
    return startAction;
  }
  // configuracion del buscador de modelos
  public getCompanySearchFieldConfig(): FieldConfig {
    let config = new FieldConfig();
    config.type = 'SEARCH';
    config.tooltipText = 'Seleccionar empresa adjudicataria';
    config.jsonField = 'company';
    config.description = 'Empresa adjudicataria:';
    config.autoSearch = false;
    config.idBuscador = 'com.nexusit.plyca.admin.interfaz.BuscadorEmpresasRIL';
    config.columnStyle = 'col-12';
    return config;
  }

  createModel() {
    console.log('SELECCIONADA OPCION PARA CREAR MODELO');
  }

  createProjectFromModel() {
    console.log('SELECCIONADA OPCION PARA CREAR MODELO');
    // TODO
    this.dossierId = '20190004000877';
    this.subscribe(this.loadStepsDefinition());
  }

  getFormIdFromTask(formidBD: string) {
    let formId = formidBD;
    if (this.task) {
      let variable = this.task.taskData.find(data => data.name === 'ID_FORMULARIO')
      if (variable && variable.value != '') {
        formId = variable.value;
      }
    }
    return formId;
  }

  // Este metodo obtiene los datos del Acuerdo Marco
  // y establece los datos al Contrato Basado
  public setContractBasedFrameworkAgreement(model: any) {
    console.log('*** Se cargan los datos del Acuerdo Marco en el Contrato Basado ****');
    if (
      model.contractingSystem &&
      model.contractingSystem.originalContractingSystemID
    ) {
      let identifier =
        model.contractingSystem.originalContractingSystemID.identifier;

      // Si existe Acuerdo Marco
      if (identifier) {
        let expansionDossier: string;
        if (identifier && identifier.indexOf('?') > 0) {
          expansionDossier = '&';
        } else {
          expansionDossier = '?';
        }
        expansionDossier = expansionDossier + 'expand=expansionSet:subclass_complete';


        this.subscribe(this.plycaService
          .getProcurementProjectAM(identifier, expansionDossier)
          ,
          (result: ProcurementProjectDTO) => {
            model.procurementProjectAM = result;
            if (
              model.procurementProjectAM &&
              model.procurementProjectAM.contractingSystem
            ) {
              if (model.classification && model.classification.complementarySystem) {
                // Variables de Acuerdos Marco y Contratos Basados
                let isAM = model.classification.complementarySystem.identifier == 'AM<>SISTCOMPLEMENTARIO';
                let isCBAM = model.classification.complementarySystem.identifier == 'CBAM<>SISTCOMPLEMENTARIO';

                let baseContractNoRelated = false;
                if (this.isActiveBaseContractNoRelated) {
                  // Si esta activa la funcionalidad de contratos basados sin padre
                  baseContractNoRelated = model.contractingSystem && model.contractingSystem.baseContractNoRelated;
                }

                // Precarga de datos de contratos basados
                if (isCBAM) {

                  // Si tiene padre
                  if (!baseContractNoRelated) {
                    let isFrameworkAgreementCriteria = false;
                    if (model.procurementProjectAM.contractingSystem != null
                      && model.procurementProjectAM.contractingSystem.frameworkAgreementCriteria != null) {
                      isFrameworkAgreementCriteria = model.procurementProjectAM.contractingSystem.frameworkAgreementCriteria;
                      model.contractingSystem.frameworkAgreementCriteria = isFrameworkAgreementCriteria;
                    }
                    if (isFrameworkAgreementCriteria) {
                      if (model.procurementProjectAM.contractingSystem.tenderBasedFrameworkAgreement) {
                        model.contractingSystem.tenderBasedFrameworkAgreement
                          = model.procurementProjectAM.contractingSystem.tenderBasedFrameworkAgreement;
                      }
                    } else {
                      // Pendiente de desactivar el campo
                      model.contractingSystem.criteriaConcretion = model.procurementProjectAM.contractingSystem.criteriaConcretion;
                      model.contractingSystem.tenderBasedFrameworkAgreement = true;

                    }
                  } else {
                    // Sino tiene padre
                    model.contractingSystem.tenderBasedFrameworkAgreement = true;
                  }

                  // Si es si el valor de Tramitar Nueva Licitacion, se establece el valor por defecto de tramitación anticipada a no
                  if (model.contractingSystem.tenderBasedFrameworkAgreement) {
                    model.classification.procurementCommittee = false;
                  }

                }
              }
              // Sino tiene lotes se cargan los datos del Padre
              if (model.procurementProjectAM.breakdownLot.apportioned == false) {
                // this.loadDataAMSDA(model).subscribe();
                if (
                  model.contractingSystem &&
                  model.contractingSystem.originalContractingSystemID
                ) {
                  let contractFolderId =
                    model.contractingSystem.originalContractingSystemID.contractFolderId;
                  // let categoria = model.contractingSystem.originalContractingSystemLotID;
                  if (contractFolderId) {
                    // Es un acuerdo marco sin lotes
                    let loteId = 0;
                    let confirmMessage = this.translationService.instant(
                      'ProcurementProjectLot.loadCriterialAM'
                    );
                    this.uiService.showConfirmMessage({
                      message: confirmMessage,
                      header: 'Confirmation',
                      icon: 'pi pi-exclamation-triangle',
                      accept: () => {

                        // 1. Se cargan los materiales solicitados
                        let urlRequestedMaterial =
                          this.configuration.REQUEST_MATERIAL_SERVICE_URL +
                          '?contractFolderId=' +
                          contractFolderId +
                          '&lotId=' +
                          loteId;
                        this.subscribe(this.plycaService.query<RequestMaterialDTO>(urlRequestedMaterial),
                          (_result: PaginationDTO<RequestMaterialDTO>) => {
                            if (
                              _result &&
                              _result.content
                            ) {
                              model.breakdownLot.totalLots.requestedMaterial = [];
                              if (model.desglosableInfo['requestedMaterial']) {
                                model.desglosableInfo['requestedMaterial'] = [];
                              }
                              _result.content.forEach(
                                (material: RequestMaterialDTO) => {
                                  material.lot = null;
                                  material.identifier = undefined;
                                  model.desglosableInfo['requestedMaterial'].push(
                                    material
                                  );
                                }
                              );
                            }
                          },
                          (error: any) => this.plycaErrorHandler.showServerError(error)
                        );

                        // 2. Se cargan las empresas a invitar
                        let urlCompanyToInvite =
                          this.configuration.AWARD_SERVICE_URL +
                          '?contractFolderId=' +
                          contractFolderId +
                          '&lotsId=' +
                          loteId +
                          '&expand=expansionset:lotscompany';

                        urlCompanyToInvite = this.configuration.AWARD_SERVICE_URL +
                          '?contractFolderId=' +
                          contractFolderId;

                        this.subscribe(this.plycaService.query<AwardDTO>(urlCompanyToInvite),
                          (resultAdjudicaciones: PaginationDTO<AwardDTO>) => {

                            if (
                              resultAdjudicaciones &&
                              resultAdjudicaciones.content
                            ) {
                              let companiesToInvites = new Array<CompanyToInviteDTO>();
                              resultAdjudicaciones.content.forEach((award: AwardDTO) => {
                                // generar objeto company
                                let companyToInvite = new CompanyToInviteDTO();
                                companyToInvite.company = award.company;
                                companiesToInvites.push(companyToInvite);
                              });
                              model.breakdownLot.totalLots.companyToInvites = companiesToInvites;
                            }
                          },
                          (error: any) => this.plycaErrorHandler.showServerError(error)
                        );

                        // 3. Se cargan los criterios de ajudicacion
                        let urlAwardCriteria =
                          this.configuration.PROCUREMENTPROJLOT_ONLY_SERVICE_ACTION +
                          '?contractFolderId=' +
                          contractFolderId +
                          '&lotId=' +
                          loteId +
                          '&expand=expansionSet:basic_criteria';

                        this.subscribe(this.plycaService
                          .query<ProcurementProjectLotDTO>(urlAwardCriteria),
                          (resultL: PaginationDTO<ProcurementProjectLotDTO>) => {
                            if (
                              resultL &&
                              resultL.content
                            ) {
                              model.breakdownLot.totalLots.selectionAwardCriteria = [];
                              if (model.desglosableInfo['selectionAwardCriteria']) {
                                model.desglosableInfo['selectionAwardCriteria'] = [];
                              }

                              // resultL.content.forEach((lot: ProcurementProjectLotDTO) => lot.selectionAwardCriteria.forEach(
                              resultL.content
                                .filter((lot: ProcurementProjectLotDTO) =>
                                  lot.selectionAwardCriteria && lot.selectionAwardCriteria.length > 0
                                ).forEach((lot: ProcurementProjectLotDTO) => lot.selectionAwardCriteria.forEach(
                                  (criteria: CriteriaDTO) => {
                                    criteria.identifier = undefined;
                                    model.desglosableInfo['selectionAwardCriteria'].push(
                                      criteria
                                    );
                                  }
                                ));
                            }
                          },
                          (error: any) => this.plycaErrorHandler.showServerError(error)
                        );
                        return model;
                      }, reject: () => {
                        console.log('NO SE CARGAN LOS DATOS EXPEDIENTE RELACIONADO (AM, SDA)');
                      }
                    });

                  }

                }
              }
            }

          }, (error: any) => this.plycaErrorHandler.showServerError(error)
        );
      }




    } else {
      model.procurementProjectAM = null;
    }
    return model;
  }

  public isActiveBaseContractNoRelated(model: any) {
    let activeBaseContractNoRelated =
      (model.context &&
        model.context.configurations &&
        model.context.configurations.isBaseContractNoRelated)
        ? model.context.configurations.isBaseContractNoRelated.value
        : false;

    if (activeBaseContractNoRelated) {
      return true;
    } else {
      return false;
    }

  }

  public setDefaultValueFrameworkAgreementCriteria(model: any) {

    // Si es un Acuerdo Marco, se establecen los valores por defecto
    let isCBAM = model.classification.complementarySystem && model.classification.complementarySystem.identifier == 'CBAM<>SISTCOMPLEMENTARIO';
    let activeBaseContractNoRelated =
      (model.context &&
        model.context.configurations &&
        model.context.configurations.isBaseContractNoRelated)
        ? model.context.configurations.isBaseContractNoRelated.value
        : false;

    if (isCBAM && model.contractingSystem) {
      // Si esta activa la funcionalidad de contratos basados sin padre y esta marcado el check
      if (activeBaseContractNoRelated) {
        let baseContractNoRelated = model.contractingSystem && model.contractingSystem.baseContractNoRelated;
        model.contractingSystem.frameworkAgreementCriteria = baseContractNoRelated;
        model.contractingSystem.tenderBasedFrameworkAgreement = true;
      }
    }

  }

  public isEnabledTenderBasedFrameworkAgreement(model: any) {
    let enabled = true;

    if (model.classification && model.classification.complementarySystem) {
      let isCBAM = model.classification.complementarySystem.identifier == 'CBAM<>SISTCOMPLEMENTARIO';
      let baseContractNoRelated = false;

      // Si existe AM Padre o no
      baseContractNoRelated = model.contractingSystem && model.contractingSystem.baseContractNoRelated != undefined
        && model.contractingSystem.baseContractNoRelated != null && model.contractingSystem.baseContractNoRelated;
      // Precarga de datos de contratos basados
      if (isCBAM && !baseContractNoRelated) {
        // Se supone que ya esta cargado con los datos del AM padre el campo
        if (model.contractingSystem != null && model.contractingSystem.frameworkAgreementCriteria != null
          && !model.contractingSystem.frameworkAgreementCriteria) {
          enabled = false;
        }
      }
    }
    return enabled;
  }

  public isVisibleCategory(model: any) {
    // desglosable en lotes el acuerdo marco
    if (ProcurementProjectValidations.isComplementarySystem_CBAM_CSDA(model)) {
      if (model.contractingSystem.originalContractingSystemID != undefined && model.contractingSystem.originalContractingSystemID) {
        // Visible Unicamente si esta desglosado en lotes
        if (model.procurementProjectAM && model.procurementProjectAM.breakdownLot && model.procurementProjectAM.breakdownLot.apportioned) {
          return true;
        }
      }
    }
    return false;
  }


  isJsonFieldInForm(jsonField: string): boolean {
    if (this.form && this.form.groups && this.form.groups.length > 0) {
      return this.form.groups.filter((group: FormGroupConfig) => {
        return group.group.fieldList.filter((field: FieldConfig) => field.jsonField === jsonField).length > 0;
      }).length > 0;
    } else {
      return false;
    }
  }

  isBudgetCalculateVisible(): boolean {
    if (this.form && this.form.groups && this.form.groups.length > 0 && !this.form['showCalculateButton']) {
      this.form['showCalculateButton']
        = (this.isJsonFieldInForm('budget.totalAmount') && this.isJsonFieldInForm('budget.taxType')).toString();
    }
    return this.form && this.form.groups && this.form.groups.length > 0 && this.form['showCalculateButton'] === 'true';
  }

  private roundDecimals(value: number, decimals?: number): number {
    let digits: number = (decimals || decimals == 0) ? decimals : 2;
    let multiplier = Math.pow(10, digits);
    return Math.round((value + Number.EPSILON) * multiplier) / multiplier;
  }

  public calculateBudgets() {
    let model: ProcurementProjectDTO = this.form.formConfig.model;

    // Calculamos el tipo de impuestos
    let taxRateValue;
    if (model.budget.taxRate) {
      taxRateValue = model.budget.taxRate.trim().replace('%', '').replace(',', '.');
    }
    // Si no hay un tipo valido mostramos un mensaje
    if (!taxRateValue || isNaN(taxRateValue)) {
      this.uiService.showSuccess(this.translate.instant('ProcurementProject.calculate.noTaxRate'),
        this.translate.instant('General.warning'), 'warn');
    }

    // Almacenamos antes del calculo que el presupusto y el valor estimado son iguales
    // o sólo se ha modificado el importe del presupuesto ya que el impuesto sobre el estimado
    // es igual a los impuestos actuales(presupuesto antes del último calculo)
    let isEqualsEstimated: boolean = !model.budget.estimatedAmount
      || model.budget.amountExcludingTaxes === model.budget.estimatedAmount
      || (taxRateValue && model.budget.amountExcludingTaxes && model.budget.totalTaxes
        === (this.roundDecimals(model.budget.estimatedAmount * (taxRateValue / 100), 2)));
    if (!isEqualsEstimated) {
      this.uiService.showSuccess(this.translate.instant('ProcurementProject.calculate.noEstimatedBudgetUpdate'),
        this.translate.instant('General.warning'), 'warn');
    }

    // Si hay material solicitado sumamos y calculamos a partir del mismo
    if (this.isJsonFieldInForm('desglosableInfo.requestedMaterial') && model.desglosableInfo
      && model.desglosableInfo.requestedMaterial && model.desglosableInfo.requestedMaterial.length > 0) {
      let sumMaterialBudget = 0;
      model.desglosableInfo.requestedMaterial.forEach((matLine: RequestMaterialDTO) => { sumMaterialBudget += matLine.totalAmount });
      model.budget.amountExcludingTaxes = this.roundDecimals(sumMaterialBudget, 2);
      if (this.isJsonFieldInForm('budget.estimatedAmount') && isEqualsEstimated && model.budget.amountExcludingTaxes) {
        // Si hay importe presupuesto y el estimado no se ha esteblecido manualmente se igualan estimado y presupuesto
        model.budget.estimatedAmount = this.roundDecimals(model.budget.amountExcludingTaxes, 2);
      }
      if (taxRateValue && model.budget.amountExcludingTaxes) {
        // Si hay tipo impositivo calculamos el importe impuestos
        model.budget.totalTaxes = this.roundDecimals(model.budget.amountExcludingTaxes * (taxRateValue / 100), 2);
      }

    } else if (this.isJsonFieldInForm('breakdownLot.lots') && model.breakdownLot && model.breakdownLot.lots
      && model.breakdownLot.lots.length > 1) {
      // En caso contrario si hay lotes lo calculamos desde estos
      let sumLotBudget = 0;
      let sumLotTaxes = 0;
      let sumLotEstimated = 0;
      model.breakdownLot.lots.forEach((lot: ProcurementProjectLotDTO) => {
        let isLotEqualsEstimated: boolean = !lot.budget.estimatedAmount
          || lot.budget.amountExcludingTaxes === lot.budget.estimatedAmount
          || (taxRateValue && lot.budget.amountExcludingTaxes
            && lot.budget.totalTaxes === (this.roundDecimals(lot.budget.estimatedAmount * (taxRateValue / 100), 2)));

        if (taxRateValue && lot.budget.amountExcludingTaxes != undefined) {
          // Si hay tipo impositivo calculamos el importe de los impuestos
          lot.budget.totalTaxes = this.roundDecimals(lot.budget.amountExcludingTaxes * (taxRateValue / 100), 2);
          lot.budget.totalAmount = this.roundDecimals(lot.budget.amountExcludingTaxes + lot.budget.totalTaxes, 2);
        }

        if (isLotEqualsEstimated && lot.budget.amountExcludingTaxes != undefined) {
          // Si hay importe presupuesto y el estimado no se ha esteblecido manualmente se igualan estimado y presupuesto
          lot.budget.estimatedAmount = this.roundDecimals(lot.budget.amountExcludingTaxes, 2);
        }
        sumLotBudget += lot.budget.amountExcludingTaxes;
        sumLotTaxes += lot.budget.totalTaxes;
        sumLotEstimated += lot.budget.estimatedAmount;
      });
      model.budget.amountExcludingTaxes = this.roundDecimals(sumLotBudget, 2);
      model.budget.totalTaxes = this.roundDecimals(sumLotTaxes, 2);
      model.budget.estimatedAmount = this.roundDecimals(sumLotEstimated, 2);
    } else {
      // Si no hay lotes
      if (this.isJsonFieldInForm('budget.estimatedAmount') && isEqualsEstimated && model.budget.amountExcludingTaxes != undefined) {
        // Si hay importe presupuesto y el estimado no se ha esteblecido manualmente se igualan estimado y presupuesto
        model.budget.estimatedAmount = this.roundDecimals(model.budget.amountExcludingTaxes, 2);
      }

      if (this.isJsonFieldInForm('budget.totalTaxes') && taxRateValue && model.budget.amountExcludingTaxes != undefined) {
        // Si hay tipo impositivo calculamos el importe impuestos
        model.budget.totalTaxes = this.roundDecimals(model.budget.amountExcludingTaxes * (taxRateValue / 100), 2);
      }
    }

    // Si solo hay una anualidad aplicación
    if (this.isJsonFieldInForm('budget.budgetAccounLine')) {
      if (model.budget.budgetAccounLine && model.budget.budgetAccounLine.length == 1) {
        model.budget.budgetAccounLine[0].budget.totalAmount
          = this.roundDecimals(model.budget.amountExcludingTaxes + model.budget.totalTaxes, 2);
      } else if (model.budget.budgetAccounLine && model.budget.budgetAccounLine.length == 0) {
        this.uiService.showSuccess(this.translate.instant('ProcurementProject.calculate.noAccountLines'),
          this.translate.instant('General.warning'), 'warn');
      } else if (model.budget.budgetAccounLine && model.budget.budgetAccounLine.length > 1) {
        this.uiService.showSuccess(this.translate.instant('ProcurementProject.calculate.manyAccountLines'),
          this.translate.instant('General.warning'), 'warn');
      }
    }

    // Si hay lotes y material solicitado calculamos importes de cada lote
    if (this.isJsonFieldInForm('breakdownLot.lots') && model.breakdownLot && model.breakdownLot.lots && model.breakdownLot.lots.length > 1
      && model.desglosableInfo && model.desglosableInfo.requestedMaterial && model.desglosableInfo.requestedMaterial.length > 0) {
      model.breakdownLot.lots.forEach((lot: ProcurementProjectLotDTO) => {
        let sumMaterialBudget = 0;
        let matLines: RequestMaterialDTO[] = model.desglosableInfo.requestedMaterial
          .filter((matLine: RequestMaterialDTO) => {
            if (matLine.listaLotes) {
              return matLine.listaLotes.filter((matLot: ProcurementProjectLotDTO) => matLot.identifier === lot.identifier).length > 0
            }
            return false;
          });
        matLines.forEach((matLine: RequestMaterialDTO) => { sumMaterialBudget += matLine.totalAmount });
        lot.budget.amountExcludingTaxes = this.roundDecimals(sumMaterialBudget, 2);
        if (taxRateValue && lot.budget.amountExcludingTaxes != undefined) {
          lot.budget.totalTaxes = this.roundDecimals(lot.budget.amountExcludingTaxes * (taxRateValue / 100), 2);
          lot.budget.totalAmount = this.roundDecimals(lot.budget.amountExcludingTaxes + lot.budget.totalTaxes, 2);
        }
        if (isEqualsEstimated) {
          lot.budget.estimatedAmount = this.roundDecimals(lot.budget.amountExcludingTaxes, 2);
        }
      });
    }
  }

  public getURLRequestedMaterial(contractFolderId: string, lotId: number) {
    let url =
      this.configuration.REQUEST_MATERIAL_SERVICE_URL +
      '?contractFolderId=' +
      contractFolderId +
      '&lotId=' +
      lotId;

    return url;
  }



  public getURLCompanyToInvite(contractFolderId: string, lotId: number) {
    let url =
      this.configuration.AWARD_SERVICE_URL +
      '?contractFolderId=' +
      contractFolderId +
      '&lotsId=' +
      lotId +
      '&expand=expansionset:lotscompany';
    return url;
  }

  public getURLCriteriaAward(contractFolderId: string, lotId: number) {
    let url =
      this.configuration.PROCUREMENTPROJLOT_ONLY_SERVICE_ACTION +
      '?contractFolderId=' +
      contractFolderId +
      '&lotId=' +
      lotId +
      '&expand=expansionSet:basic_criteria';
    return url;
  }

  public setCriteriaAward(contractFolderId: string, lotId: number, model: any) {
    let url = this.getURLCriteriaAward(contractFolderId, lotId);

    this.subscribe(this.plycaService
      .query<ProcurementProjectLotDTO>(url),
      (result: PaginationDTO<ProcurementProjectLotDTO>) => {
        if (
          result &&
          result.content
        ) {
          model.breakdownLot.totalLots.selectionAwardCriteria = [];
          if (model.desglosableInfo['selectionAwardCriteria']) {
            model.desglosableInfo['selectionAwardCriteria'] = [];
          }
          result.content.forEach((lot: ProcurementProjectLotDTO) => lot.selectionAwardCriteria.forEach(
            (criteria: CriteriaDTO) => {
              criteria.identifier = undefined;
              model.desglosableInfo['selectionAwardCriteria'].push(
                criteria
              );
            }
          ));
        }
      },
      (error: any) => this.plycaErrorHandler.showServerError(error)
    );
    return model;
  }

  // Este metodo carga los Materiales Solicitados, Empresas a Invitar
  // y Criterios de Adjudicación del AM o SDA padre
  public loadDataAMSDA(model: any): Observable<any> {
    if (
      model.contractingSystem &&
      model.contractingSystem.originalContractingSystemID
    ) {
      let contractFolderId =
        model.contractingSystem.originalContractingSystemID.contractFolderId;
      // let categoria = model.contractingSystem.originalContractingSystemLotID;
      if (contractFolderId) {
        let loteId = null;
        // AM con lotes
        if (model.contractingSystem.originalContractingSystemLotID) {
          loteId = model.contractingSystem.originalContractingSystemLotID.lotId;
        } else {
          // AM sin lotes
          if (model.procurementProjectAM.breakdownLot.apportioned == false) {
            loteId = 0;
          }
        }

        if (loteId) {

          // Solo se tiene que hacer si ha elegido una categoria
          let confirmMessage = this.translationService.instant(
            'ProcurementProjectLot.loadCriterialAM'
          );

          this.uiService.showConfirmMessage({
            message: confirmMessage,
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {

              // 1. Se cargan los materiales solicitados
              let urlRequestedMaterial =
                this.configuration.REQUEST_MATERIAL_SERVICE_URL +
                '?contractFolderId=' +
                contractFolderId +
                '&lotId=' +
                loteId;
              this.subscribe(this.plycaService.query<RequestMaterialDTO>(urlRequestedMaterial),
                (result: PaginationDTO<RequestMaterialDTO>) => {
                  if (
                    result &&
                    result.content
                  ) {
                    model.breakdownLot.totalLots.requestedMaterial = [];
                    if (model.desglosableInfo['requestedMaterial']) {
                      model.desglosableInfo['requestedMaterial'] = [];
                    }
                    result.content.forEach(
                      (material: RequestMaterialDTO) => {
                        material.lot = null;
                        material.identifier = undefined;
                        model.desglosableInfo['requestedMaterial'].push(
                          material
                        );
                      }
                    );
                  }
                },
                (error: any) => this.plycaErrorHandler.showServerError(error)
              );

              // 2. Se cargan las empresas a invitar
              let urlCompanyToInvite =
                this.configuration.AWARD_SERVICE_URL +
                '?contractFolderId=' +
                contractFolderId;

              if (loteId != 0) {// Se le pasa el identificador del lote
                urlCompanyToInvite =
                  this.configuration.AWARD_SERVICE_URL +
                  '?contractFolderId=' +
                  contractFolderId +
                  '&lotsId=' +
                  loteId +
                  '&expand=expansionset:lotscompany';
              }

              this.subscribe(this.plycaService.query<AwardDTO>(urlCompanyToInvite),
                (resultAdjudicaciones: PaginationDTO<AwardDTO>) => {

                  if (
                    resultAdjudicaciones &&
                    resultAdjudicaciones.content
                  ) {
                    let companiesToInvites = new Array<CompanyToInviteDTO>();
                    resultAdjudicaciones.content.forEach((award: AwardDTO) => {
                      // generar objeto company
                      let companyToInvite = new CompanyToInviteDTO();
                      companyToInvite.company = award.company;
                      companiesToInvites.push(companyToInvite);
                    });
                    model.breakdownLot.totalLots.companyToInvites = companiesToInvites;
                  }
                },
                (error: any) => this.plycaErrorHandler.showServerError(error)
              );

              // 3. Se cargan los criterios de ajudicacion
              let urlAwardCriteria =
                this.configuration.PROCUREMENTPROJLOT_ONLY_SERVICE_ACTION +
                '?contractFolderId=' +
                contractFolderId +
                '&lotId=' +
                loteId +
                '&expand=expansionSet:basic_criteria';

              this.subscribe(this.plycaService
                .query<ProcurementProjectLotDTO>(urlAwardCriteria),
                (result: PaginationDTO<ProcurementProjectLotDTO>) => {
                  if (
                    result &&
                    result.content
                  ) {
                    model.breakdownLot.totalLots.selectionAwardCriteria = [];
                    if (model.desglosableInfo['selectionAwardCriteria']) {
                      model.desglosableInfo['selectionAwardCriteria'] = [];
                    }
                    result.content.filter((lot: ProcurementProjectLotDTO) =>
                      lot.selectionAwardCriteria && lot.selectionAwardCriteria.length > 0
                    ).forEach((lot: ProcurementProjectLotDTO) => lot.selectionAwardCriteria.forEach(
                      // result.content.forEach((lot: ProcurementProjectLotDTO) => lot.selectionAwardCriteria.forEach(
                      (criteria: CriteriaDTO) => {
                        criteria.identifier = undefined;
                        model.desglosableInfo['selectionAwardCriteria'].push(
                          criteria
                        );
                      }
                    ));
                  }
                },
                (error: any) => this.plycaErrorHandler.showServerError(error)
              );
              return model;
            }, reject: () => {
              console.log('NO SE CARGAN LOS DATOS EXPEDIENTE RELACIONADO (AM, SDA)');
            }
          });

        }
      }
    }
    return model;
  }

  ////  FUNCIONES PARA GOBERNANZA /////

  // Valor del campo Directiva de aplicacion
  public valueEUDirective(model: any) {


    // Valor del campo Directiva de aplicacion
    if (ProcurementProjectValidations.isMinorContrat(model)) {
      model.euDirective = {};
      model.euDirective.identifier = 'N/A<>DIRECTIVA_UE';
    } else {
      if (model.applicableLegislation.identifier == '04<>VERSIONNORMATIVA') {
        if (ProcurementProjectValidations.isServicesConcession(model) || ProcurementProjectValidations.isWorkConcession(model)) {
          model.euDirective = {};
          model.euDirective.identifier = '2014/23/EU<>DIRECTIVA_UE';
        } else {
          model.euDirective = {};
          model.euDirective.identifier = '2014/24/EU<>DIRECTIVA_UE';
        }
      }
    }


  }

  public valueNumLicitableLots(model: any) {
    if (model.breakdownLot && model.breakdownLot.apportioned && model.breakdownLot.tenderAllLots) {
      model.breakdownLot.numLicitableLots = null;
    } else {
      model.breakdownLot.numLicitableLots;
    }
  }

  public valueConfidentialityPeriod(model: any) {
    let confidentialityPeriod = '5 años';
    if (model.characteristicsContractObject.activeConfidentialityPeriod != null
      && model.characteristicsContractObject.activeConfidentialityPeriod) {
      if (!model.characteristicsContractObject.confidentialityPeriod) {
        model.characteristicsContractObject.confidentialityPeriod = '5 años';
      }
    }
  }



  public setContractBasedCatalog(model: any) {
    // Si es un Contrato Basado que se ha dado de alta desde catalogos
    console.log('*** Se cargan los datos del Acuerdo Marco en el Contrato Basado ****');
    if (
      model.contractingSystem &&
      model.contractingSystem.originalContractingSystemID
    ) {

      // Propuestaid del Acuerdo Marco Padre
      let identifier = model.procurementProjectAM.identifier;

      let contractFolderId =
        model.contractingSystem.originalContractingSystemID.contractFolderId;

      let isCatalogProject = false;

      if (contractFolderId && model.desglosableInfo['requestedMaterial']) {
        isCatalogProject = model.desglosableInfo['requestedMaterial'].filter((material: RequestMaterialDTO) =>
          (material.catalogId != undefined && material.catalogId != null)
        ).length > 0;
      }

      // Si existe Acuerdo Marco
      if (identifier && isCatalogProject) {
        let expansionDossier: string;
        if (identifier && identifier.indexOf('?') > 0) {
          expansionDossier = '&';
        } else {
          expansionDossier = '?';
        }
        expansionDossier = expansionDossier + 'expand=expansionSet:subclass_complete';

        this.subscribe(this.plycaService
          .getProcurementProjectAM(identifier, expansionDossier),
          (result: ProcurementProjectDTO) => {
            model.procurementProjectAM = result;
            if (
              model.procurementProjectAM &&
              model.procurementProjectAM.contractingSystem
            ) {
              if (model.classification && model.classification.complementarySystem) {
                let isCBAM = model.classification.complementarySystem.identifier == 'CBAM<>SISTCOMPLEMENTARIO';

                // Si es contrato basado de  un expediente de catalogos
                if (isCBAM) {


                  // Unicamente en el caso de no tenga valor el campo "frameworkAgreementCriteria"
                  if (model.contractingSystem.frameworkAgreementCriteria == undefined
                    || model.contractingSystem.frameworkAgreementCriteria == null) {

                    // 1. Precarga de datos de contratos basados, de catalogos
                    let isFrameworkAgreementCriteria = false;
                    if (model.procurementProjectAM.contractingSystem != null
                      && model.procurementProjectAM.contractingSystem.frameworkAgreementCriteria != null) {
                      isFrameworkAgreementCriteria = model.procurementProjectAM.contractingSystem.frameworkAgreementCriteria;
                      model.contractingSystem.frameworkAgreementCriteria = isFrameworkAgreementCriteria;
                    }
                    if (isFrameworkAgreementCriteria) {
                      if (model.procurementProjectAM.contractingSystem.tenderBasedFrameworkAgreement) {
                        model.contractingSystem.tenderBasedFrameworkAgreement
                          = model.procurementProjectAM.contractingSystem.tenderBasedFrameworkAgreement;
                      }
                    } else {
                      // Pendiente de desactivar el campo
                      model.contractingSystem.criteriaConcretion = model.procurementProjectAM.contractingSystem.criteriaConcretion;
                      model.contractingSystem.tenderBasedFrameworkAgreement = true;

                    }

                    // Si es si el valor de Tramitar Nueva Licitacion, se establece el valor por defecto de tramitación anticipada a no
                    if (model.contractingSystem.tenderBasedFrameworkAgreement) {
                      model.classification.procurementCommittee = false;
                    }

                    // 2. Se cargan los criterios de adjudicacion del padre

                    // Un expediente de catalogos no tiene lotes
                    let loteId = 0;

                    // Se cargan los criterios de ajudicacion
                    let urlAwardCriteria =
                      this.configuration.PROCUREMENTPROJLOT_ONLY_SERVICE_ACTION +
                      '?contractFolderId=' +
                      contractFolderId +
                      '&lotId=' +
                      loteId +
                      '&expand=expansionSet:basic_criteria';

                    this.subscribe(this.plycaService
                      .query<ProcurementProjectLotDTO>(urlAwardCriteria),
                      (resultAward: PaginationDTO<ProcurementProjectLotDTO>) => {
                        if (
                          resultAward &&
                          resultAward.content
                        ) {
                          model.breakdownLot.totalLots.selectionAwardCriteria = [];
                          if (model.desglosableInfo['selectionAwardCriteria']) {
                            model.desglosableInfo['selectionAwardCriteria'] = [];
                          }
                          resultAward.content.filter((lot: ProcurementProjectLotDTO) =>
                            lot.selectionAwardCriteria && lot.selectionAwardCriteria.length > 0
                          ).forEach((lot: ProcurementProjectLotDTO) => lot.selectionAwardCriteria.forEach(
                            // resultAward.content.forEach((lot: ProcurementProjectLotDTO) => lot.selectionAwardCriteria.forEach(
                            (criteria: CriteriaDTO) => {
                              criteria.identifier = undefined;
                              model.desglosableInfo['selectionAwardCriteria'].push(
                                criteria
                              );
                            }
                          ));
                        }
                      },
                      (error: any) => this.plycaErrorHandler.showServerError(error)
                    );
                  }
                }
              }

            }
          }, (error: any) => this.plycaErrorHandler.showServerError(error)
        );
      }
    }
    return model;
  }

  private getListaLotes(model: ProcurementProjectDTO): any[] {

    let elements = [];

    if (model.breakdownLot.lots !== undefined) {
      model.breakdownLot.lots.forEach(item => {
        elements.push(this.reduceLot(item));
      });

      return elements;
    }
  }

  private getListaRelacionesAsSecundary(model: ProcurementProjectDTO): any[] {
    let elements = [];
    if (model.projectRelations !== undefined) {
      let relationProject = new ProjectRelationDTO();
      relationProject = model.projectRelations['4'];
      if (relationProject !== undefined) {
        for (let i = 0; i <= relationProject.relationsAsSecundary.length - 1; i++) {
          let relacion = new ProjectRelationTable;
          relacion.relationType = relationProject.relation;
          relacion.secundaryRelation = relationProject.relationsAsSecundary[i];
          elements.push(relacion);
        }
      }
    }
    return elements;
  }

  public clearLotTotalTaxes(model: any) {
    let noTax = (model.budget &&
      model.budget.taxType &&
      model.budget.taxType.identifier == '0<>TIPO_IMPUESTO');

    // Si es un expediente sin IVA, Se limpia el IVA DE todos los lotes
    if (noTax) {
      let elements = [];
      if (model.breakdownLot && model.breakdownLot.lots && model.breakdownLot.lots.length > 0) {
        model.breakdownLot.lots.forEach(item => {
          item.budget.totalTaxes = 0;
        });
      }
    }
  }

  openActionModal(action: ActionDTO) {

    let config: DynamicDialogConfig = {
      header: action.name,
      width: '70%',
      styleClass: 'actionStyle',
    };
    config['action'] = action;
    config['dto'] = action.target;

    return this.dialogService.open(ActionsProcessComponent, config);
  }

  public SUEZopenActionImportCompany() {
    let confirmMessage = 'Al importar las empresas se volvacará el contenido del fichero seleccionado a la tabla, eliminando la información previa. ¿Desea continuar?';
    this.uiService.showConfirmMessage({
      message: confirmMessage,
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.subscribe(this.plycaService.getAction('IMPORT_COMPANY_TO_INVITE_FROM_EXCEL'), (datos: any) => {
          if (datos && datos.content) {
            let actionDefinition: ActionDefinitionDTO = datos.content[0];

            if (actionDefinition && actionDefinition.executableAction) {
              let act = actionDefinition.executableAction;
              act.target = this.task;
              act.parameters = act.parameters.filter(
                (param) => param.name !== 'TARGET'
              );

              let config: DynamicDialogConfig = {
                header: actionDefinition.executableAction.name,
                width: '70%',
                styleClass: 'actionStyle',
              };
              config['action'] = actionDefinition.executableAction;
              config['dto'] = actionDefinition.executableAction.target;

              const ref = this.dialogService.open(ActionsProcessComponent, config);
              this.subscribe(ref.onClose, (result: any) => {
                let _this = this as unknown as formElementComponent;
                if (result && result.length) {
                  if (_this.model.breakdownLot && _this.model.breakdownLot.totalLots
                    && _this.model.breakdownLot.totalLots.companyToInvites) {
                    _this.model.breakdownLot.totalLots.companyToInvites = [];
                  }

                  result.forEach(item => {
                    let companyToInvite = new CompanyToInviteDTO();
                    companyToInvite.company = item;
                    _this._addRow(companyToInvite);
                  });
                }
              });
            }
          }
        });
      },
      reject: () => {
        console.log('NO SE IMPORTAN LAS EMPRESAS A INVITAR');
      }
    });
  }


  public UVAL_clearBudgetAccountLines(model: any, changes?: any) {
    console.log('EJECUTADO UVAL_clearBudgetAccountLines', model, changes);
    let reset = procurementProjectComponent.resetChange(changes);
    if (reset && model.budget?.budgetAccounLine && model.budget.budgetAccounLine.length > 0) {
      model.budget.budgetAccounLine = [];
    }
  }


  public valueSubmissionPlatform(this: any, model: any, changes?: any) {
    let submissionPlatform = model.classification.submissionPlatform;
    if (model.classification?.submissionMethodCode == true) {
      if (this.data !== undefined && this.data && this.data.length == 1) {
        submissionPlatform = this.data[0].value;
      }
    } else {
      submissionPlatform = '';
    }
    return submissionPlatform;

  }

  public valueChangeExpRel(model: any) {
    if (model.secundaryRelation) {
      //Carga anualidades. Si está activo proyecto de gasto.
      if (model._parent.context && model._parent.context.configurations
        && model._parent.context.configurations.isActiveProjects) {
        //if (this.procurementProjectValidations.isEnabledActiveProjects(model._parent)) {
        //for (let i = 0; i <= model.listaRelaciones.length - 1; i++) {
        model._parent.budget.budgetAccounLine = model.secundaryRelation.budgetAccountLines;
        model._parent.budget.fundingProgram.cofinancedLine = model.secundaryRelation.cofinancingLine;
        model._parent.budget.budgetAccounLine['_parent'] = model._parent;
        model._parent.budget.fundingProgram.cofinancedLine['_parent'] = model._parent;

        //}
      }
      //Carga cofinanciación
    }
  }

  getValidateDossier(validationGroup: string, model?: any, message?: boolean, showMessageOK?: boolean): Observable<any> {
    console.log(
      'Validando formulario. Esquema utilizado:' + validationGroup,
      model
    );

    let messageOk: string;
    messageOk = this.translate.instant('GenericDossier.validate.ok');
    if (message !== undefined && message !== null && message) {
      messageOk = this.translate.instant('GenericDossier.validate.ok_correct');
    }

    return this.plycaService.validateDTO(validationGroup, model).pipe(
      tap(validations => {
        this.form.deleteFormErrors();
        if (getResultTypeDTOLevel(validations.body.result) !== getResultTypeDTOLevel(ResultTypeDTO.OK)) {
          this.form.manageFormException(validations.body);
          //this.processDossierForm(validations.body);
        } else {
          if (showMessageOK !== undefined && showMessageOK != null && showMessageOK) {
            this.uiService.showMessage(
              messageOk,
              this.translate.instant('General.info'),
              'helpStyle'
            );
          }
        }
      }),
      catchError((error: any) => {
        console.log('manageFormException 2', error);
        this.form.manageFormException(error);
        return throwError(error);
      })
    );
  }


  verifyDossier(showMessage?: boolean, showMessageOK?: boolean) {

    if (showMessage) {
      this.waitService.startWaiting(this.translate.instant('GenericDossier.validate.validating'));
    } else {
      this.waitService.startWaiting();
    }
    let model = this.viewModel2DTO();
    let validationContext = 'procurementProjects/validations/';
    // Si hay definido un grupo de validaciones asociado al paso  prevalece sobre la definición de validación asociado al formulario
    // Si hay definido un grupo de validaciones a la definición de formulario se especifica

    let validationContextGroupValidation = this.getContext(
      model.identifier !== undefined ? true : false
    );
    if (validationContextGroupValidation) {
      validationContext += validationContextGroupValidation;
    }
    console.log(
      'Validando el expediente,',
      model,
      ' con el grupo de validaciones ',
      validationContext
    );
    if (this.form) {
      this.form.deleteFormErrors();
    }


    this.subscribe(this.getValidateDossier(validationContext, model, true, showMessageOK).pipe(
      finalize(() => this.waitService.cancelWaiting())
    ));

  }

  getValidateObservable(validationGroup: string, model?: any, viewMessage?: boolean, nextStep?: boolean): Observable<any> {

    console.log(
      'Validando formulario. Esquema utilizado:' + validationGroup,
      model
    );

    return this.plycaService.validateDTO(validationGroup, model).pipe(
      tap(validations => {
        // Si viene de un cambio de paso, no se muestran las validaciones del propio paso
        // Se llama a las validaciones del siguiente paso
        if (getResultTypeDTOLevel(validations.body.result) !== getResultTypeDTOLevel(ResultTypeDTO.OK)) {
          // Si viene de un cambio de paso y es el Paso 2
          // No muestra las validaciones del Paso 1
          if (nextStep !== undefined && nextStep != null && nextStep) {
            if (this.getCurrentStep().value == 0) {
              this.form.manageFormException(validations.body);
            }
          } else {
            this.form.manageFormException(validations.body);
          }


        } else if (!this.form.showValidationsPanel) {
          this.uiService.showMessage(
            this.translate.instant('GenericDossier.validate.ok'),
            this.translate.instant('General.info'),
            'helpStyle'
          );
        }

      }),

      catchError((error: any) => {
        this.form.deleteFormErrors();

        // Si viene de un cambio de paso, y es un fatal
        // 1. Se muestra el error, de que no se ha podido grabar el expediente

        if (viewMessage !== undefined && viewMessage !== null && viewMessage) {

          let fatalMessage = this.translate.instant('GenericDossier.validate.fatal');
          if (nextStep !== undefined && nextStep != null && nextStep) {
            fatalMessage = this.translate.instant('GenericDossier.validation.changeStepFatal');
          }
          this.uiService.showMessage(
            fatalMessage,
            this.translate.instant('General.info'),
            'helpStyle'
          );

          // En el caso de que sea una FE de dos pasos y se haya pulsado el botón de ir a un paso
          // 2. Se muestra las validaciones del Paso en el que se encuentra actualmente
          if (nextStep !== undefined && nextStep != null && nextStep) {
            this.validate();
            console.log('manageFormException 2', error);
            return throwError(error);
          }
        }

        console.log('manageFormException 2', error);
        this.form.manageFormException(error);
        return throwError(error);
      })
    );
  }




  // CAMBIOS PETICIONES ***********************************
  // Cambios botonera, se modifican las peticiones para que la validación y la actualización se haga en una petición
  /*private saveNew() {
    this.subscribe(this.saveObservable())
  }

  private saveObservable(cancelWait = true): Observable<any> {
    return this.saveDossierObservable(cancelWait);
  }

  private saveDossierObservable(cancelWait = true): Observable<any> {
    this.waitService.startWaiting(this.translateService.instant('GenericDossier.changing'));
    const dossierId = this.dossier.identifier;
    return this.insertOrUpdateProject().pipe(
      tap(() => {
        // mostrar mensaje
        const messageKey = (dossierId) ? 'GenericDossier.update.ok' : 'GenericDossier.created';
        this.uiService.showSuccess(
          this.translateService.instant(messageKey, { identifier: this.getDossierId(this.dossier) }),
          this.translateService.instant('General.info'), 'success');
      }),
      finalize(() => {
        if (cancelWait) {
          this.waitService.cancelWaiting();
        }
      })
    );
  }

  private insertOrUpdateProject(additionalQueryExpansion: string = undefined, updateModel = true): Observable<any> {
    let model = this.viewModel2DTO();
    let expansion = '?expand=expansionSet:subclass_complete,availableActions';
    let validationContext = 'procurementProjects/validations/';

    // si hay definido un grupo de validaciones asociado al paso  prevalece sobre la definición de validación asociado al formulario
    // si hay definido un grupo de validaciones a la definición de formulario se especifica

    let validationContextGroupValidation = this.getContext(
      model.identifier !== undefined ? true : false);
    if (validationContextGroupValidation) {
      validationContext += validationContextGroupValidation;
    }
    console.log(
      'VALIDANDO MODELO',
      model,
      ' con el grupo de validaciones ',
      validationContext
    );

    if (this.formPlycaRef) {
      this.formPlycaRef.deleteFormErrors();
    }
    // si es el último paso consultar acciones para ver si esta todo OK
    let obs: Observable<any>;
    if (model.identifier) {
      obs = this.plycaService.updateObject<ProcurementProjectDTO>(this.configuration.PROCUREMENTPROJ_SERVICE_URL,
        model, validationContextGroupValidation);
    } else {
      obs = this.plycaService.insert<ProcurementProjectDTO>(this.configuration.PROCUREMENTPROJ_SERVICE_URL,
        model, validationContextGroupValidation).pipe(
          tap((updatedDossier: ProcurementProjectDTO) => {
            model.identifier = updatedDossier.identifier;
            this.dossierId = model.identifier;
          })
        );
    }
    return obs.pipe(
      catchError((error: any) => {
        this.manageActionError(error, false);
        return throwError(error);
      }),
      tap((updatedProject: ProcurementProjectDTO) => {
        if (updatedProject?.validationResult && updatedProject?.validationResult?.result !== ResultTypeDTO.OK) {
          // actualizar validaciones
          this.manageActionError(new ValidationResultDTOError(updatedProject.validationResult), false);
        }
      }),
      switchMap((updatedProject: ProcurementProjectDTO) => {
        if (updateModel) {
          this.waitService.startWaiting('Consultando expediente ...');
          const queryExpansion = expansion + ((additionalQueryExpansion) ? ',' + additionalQueryExpansion : '');
          return this.plycaService.getProcurementProject(updatedProject.identifier, queryExpansion);
        } else {
          return of(updatedProject);
        }
      }),
      tap((updatedProject: ProcurementProjectDTO) => {
        if (updateModel) {
          // actualizar con información del expediente con su expansion
          this.updateProjectModel(updatedProject);
        }
      })
    );
  }

  private updateProjectModel(updatedProject: ProcurementProjectDTO): void {
    this.formService.merge(this.dossier, updatedProject);
    // marcar el formulario como no modificado tras guardar y actualizar datos en pantalla
    this.formPlycaRef.formGroup.markAsPristine();
    this.formPlycaRef.updateView();
  }*/

  setLabelSpecialServices(model: any) {
    if (model.applicableLegislation.identifier && model.applicableLegislation.identifier === '70<>VERSIONNORMATIVA') {
      return new I18nData('ProcurementProject.characteristicsContractObject.specialServicesAnexoI').messageKey;
    } else {
      return new I18nData('ProcurementProject.characteristicsContractObject.specialServices').messageKey;
    }
  }

  public valueFullNameRepresentative(model: any) {
    let description = '';
    if (model && model.representative && model.representative.name && model.representative.surname) {
      description = RepresentativeDTO.getFullName(model.representative);
      if (model.representative.description) {
        description = description + ' (' + model.representative.description + ')';
      }
      return description
    } else {
      return '';
    }
  }
}
